<template>
  <div class="fullheight">
    <div class="modal" :class="modal.show ? 'is-active' : ''">
      <div
        class="modal-background"
        style="background-color: rgba(10, 10, 10, 0.33)"
        @click="modal.show = false"
      ></div>
      <div class="modal-card">
        <section
          class="modal-card-body"
          style="border-radius: 5px"
          v-html="modal.html"
        ></section>
      </div>
      <button
        class="modal-close is-large"
        aria-label="close"
        @click="modal.show = false"
      ></button>
    </div>
    <div
      class="modal_reminder modal"
      :class="modal_reminder.show ? 'is-active' : ''"
    >
      <div
        class="modal-background"
        style="background-color: rgba(10, 10, 10, 0.33)"
        @click="closeModalAd"
      ></div>
      <div class="modal-card">
        <button
          class="modal-close is-large"
          aria-label="close"
          @click="closeModalAd"
        ></button>
        <section class="modal-card-body">
          <img
            src="../../src/assets/img/logo_Cardiff.svg"
            id="logo_modal"
            height="71"
            width="320"
            defer
          />
          <p class="modal-reminder-title">Don’t leave yet!</p>
          <p class="modal-reminder-subtitle">
            You are 60 seconds away<br />
            from your approval!
          </p>
          <button
            class="modal-reminder-button button is-link padded-button next-button"
            @click="closeModalAd"
          >
            Continue to See Offers
          </button>
        </section>
      </div>
    </div>
    <nav
      id="navbar_mobile"
      class="mobile-only"
      role="navigation"
      aria-label="main navigation"
      :class="affil ? 'navbar-' + affil : 'navbar'"
    >
      <div class="container">
        <div class="navbar-brand">
          <div class="navbar-item" id="nav-logo-container" >
          <a style="">
            <img
              :src="
                require('@/assets/img/' +
                  affil +
                  '-white-text-only-powered.png')
              "
              id="logo"
              width="95"
              height="21"
              v-if="affil"
              loading="lazy"
            />
            <img
              src="../../src/assets/img/cardiff-white-text-only2.png"
              id="logo"
              width="95"
              height="21"
              loading="lazy"
              alt="cardiff logo"
              v-else
            />
          </a>
        </div>
          <div id="progress-bar-main-container-mobile" class="mobile_container navbar-item">
            <div id="progress-bar-container-parent">
              <div id="progress-bar-container">
                <div style="display: inline;">
                  <div class="progress-bar" :style="{ width: progress_css + '%' }"></div>
                </div>
                <div id="progress_bar_point_container"  :style="{ left: progress_css + '%' }">
                  <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
                  <path d="M11.8779 6.02222C11.8779 8.79941 9.63587 11.0444 6.87793 11.0444C4.11999 11.0444 1.87793 8.79941 1.87793 6.02222C1.87793 3.24504 4.11999 1 6.87793 1C9.63587 1 11.8779 3.24504 11.8779 6.02222Z" fill="#28A745" stroke="#F1F1F1" stroke-width="2"/>
                  </svg>
                </div>
              </div>
            </div>
            <div style="text-align: right;display: inline-block;" id="progress-label">
              <span v-if="this.page < 5">{{ this.page+1 }}/{{ this.maxCompleteApp }}</span>
              <span v-else>5/5</span>
            </div>
          </div>

        </div>
      </div>
    </nav>
    <div
      class="container is-fluid fullheight"
      id="appcontainer"
      v-on:mouseleave="mouseleave($event)"
    >
      <div class="columns fullheight is-centered">
        <div
          class="column is-one-quarter"
          id="cardiff-column"
          v-if="page < 12 || !prod"
        >
          <div
            id="sidebarlogo"
            style="width: 180px; margin: auto; margin-bottom: 20px"
          >
            <img
              :src="require('../../src/assets/img/' + affil + '-square.png')"
              style="border-radius: 10px"
              loading="lazy"
              width="180px"
              height="180px"
              v-if="affil"
            />
            <img
              src="../../src/assets/img/cardiff-square.png"
              style="border-radius: 10px"
              alt="cardiff logo"
              loading="lazy"
              width="180px"
              height="180px"
              v-else
            />
            <img
              src="../../src/assets/img/poweredby.png"
              style="border-radius: 3px; margin:0 auto; width: 100px; display: block;"
              loading="lazy"
              id="powered_by_cardiff"
              width="180px"
              height="180px"
              v-if="affil"
            />
          </div>
          <h4 class="" id="tell-us-title">
            Tell us a little bit about your business
          </h4>
          <div style="margin: 0 auto;">
            <hr style="width: 60%;background-color: #999;margin: 1.5rem auto;height: 1px;"/>
          </div>
          <p id="fill-out-title" style="margin-bottom: 30px">
            Fill out our 60 seconds application<br/> and secure your approval.
          </p>

          <div style="margin: auto; width: 100%; text-align: center" id="logos-container">
            <div id="ssl_logo_container">
              <svg width="100%" height="100%" viewBox="0 0 60 43" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect y="0.680664" width="59.7138" height="42.0306" rx="4.27275" fill="#006495"/>
                <path d="M8.68929 33.165C8.61713 33.0738 8.51838 33.0074 8.39304 32.9656C8.27151 32.92 8.15567 32.8972 8.04553 32.8972C7.98096 32.8972 7.9145 32.9048 7.84613 32.92C7.77777 32.9352 7.7132 32.9599 7.65243 32.9941C7.59167 33.0245 7.54229 33.0663 7.50431 33.1194C7.46633 33.1726 7.44734 33.2372 7.44734 33.3131C7.44734 33.4347 7.49292 33.5277 7.58407 33.5923C7.67522 33.6568 7.78916 33.7119 7.92589 33.7575C8.06642 33.8031 8.21644 33.8486 8.37595 33.8942C8.53547 33.9398 8.68359 34.0044 8.82032 34.0879C8.96084 34.1715 9.07668 34.2835 9.16784 34.424C9.25899 34.5646 9.30456 34.7526 9.30456 34.988C9.30456 35.2121 9.26279 35.4077 9.17923 35.5748C9.09567 35.7419 8.98173 35.8806 8.83741 35.9907C8.69688 36.1008 8.53167 36.1825 8.34177 36.2357C8.15567 36.2889 7.95817 36.3154 7.74928 36.3154C7.48722 36.3154 7.24415 36.2756 7.02007 36.1958C6.79599 36.116 6.5871 35.9869 6.3934 35.8084L7.02577 35.1134C7.11692 35.2349 7.23086 35.3299 7.36759 35.3982C7.50811 35.4628 7.65243 35.4951 7.80056 35.4951C7.87272 35.4951 7.94488 35.4875 8.01704 35.4723C8.093 35.4533 8.15947 35.4267 8.21644 35.3925C8.27721 35.3583 8.32468 35.3147 8.35886 35.2615C8.39684 35.2083 8.41583 35.1457 8.41583 35.0735C8.41583 34.952 8.36836 34.857 8.27341 34.7886C8.18226 34.7165 8.06642 34.6557 7.92589 34.6063C7.78536 34.557 7.63344 34.5076 7.47013 34.4582C7.30682 34.4088 7.1549 34.3424 7.01437 34.2588C6.87385 34.1753 6.75611 34.0651 6.66116 33.9284C6.57001 33.7917 6.52443 33.6113 6.52443 33.3872C6.52443 33.1707 6.56621 32.9808 6.64976 32.8175C6.73712 32.6542 6.85106 32.5174 6.99158 32.4073C7.13591 32.2972 7.30112 32.2155 7.48722 32.1623C7.67332 32.1054 7.86512 32.0769 8.06262 32.0769C8.2905 32.0769 8.51078 32.1092 8.72347 32.1737C8.93616 32.2383 9.12796 32.3465 9.29887 32.4985L8.68929 33.165ZM10.0008 32.1794H12.7411V32.9998H10.8896V33.7518H12.6386V34.5722H10.8896V35.3925H12.8436V36.2129H10.0008V32.1794ZM16.1928 33.2277C16.1055 33.1213 15.9972 33.0397 15.8681 32.9827C15.7427 32.9257 15.5965 32.8972 15.4294 32.8972C15.2623 32.8972 15.1066 32.9295 14.9623 32.9941C14.8217 33.0587 14.6983 33.1498 14.592 33.2675C14.4894 33.3815 14.4077 33.5182 14.347 33.6777C14.29 33.8372 14.2615 34.0101 14.2615 34.1962C14.2615 34.3861 14.29 34.5608 14.347 34.7203C14.4077 34.876 14.4894 35.0127 14.592 35.1305C14.6945 35.2444 14.8141 35.3337 14.9509 35.3982C15.0914 35.4628 15.2414 35.4951 15.4009 35.4951C15.5832 35.4951 15.7446 35.4571 15.8852 35.3811C16.0257 35.3052 16.1415 35.1988 16.2327 35.0621L16.9733 35.6147C16.8024 35.854 16.5859 36.0306 16.3238 36.1445C16.0618 36.2585 15.7921 36.3154 15.5149 36.3154C15.1996 36.3154 14.9091 36.2661 14.6432 36.1673C14.3774 36.0686 14.1476 35.928 13.9539 35.7457C13.7602 35.5596 13.6083 35.3356 13.4981 35.0735C13.3918 34.8114 13.3386 34.519 13.3386 34.1962C13.3386 33.8733 13.3918 33.5809 13.4981 33.3188C13.6083 33.0568 13.7602 32.8346 13.9539 32.6523C14.1476 32.4662 14.3774 32.3237 14.6432 32.225C14.9091 32.1262 15.1996 32.0769 15.5149 32.0769C15.6288 32.0769 15.7465 32.0883 15.8681 32.1111C15.9934 32.13 16.1149 32.1623 16.2327 32.2079C16.3542 32.2535 16.4701 32.3142 16.5802 32.3902C16.6903 32.4662 16.7891 32.5592 16.8764 32.6694L16.1928 33.2277ZM20.8562 34.6576C20.8562 34.8969 20.8201 35.1172 20.748 35.3185C20.6758 35.5198 20.5676 35.6945 20.4232 35.8426C20.2827 35.9907 20.1061 36.1065 19.8934 36.1901C19.6807 36.2737 19.4357 36.3154 19.1585 36.3154C18.8774 36.3154 18.6306 36.2737 18.4179 36.1901C18.2052 36.1065 18.0267 35.9907 17.8824 35.8426C17.7418 35.6945 17.6355 35.5198 17.5633 35.3185C17.4912 35.1172 17.4551 34.8969 17.4551 34.6576V32.1794H18.3438V34.6234C18.3438 34.7488 18.3628 34.8646 18.4008 34.9709C18.4426 35.0773 18.4995 35.1703 18.5717 35.2501C18.6439 35.3261 18.7293 35.3868 18.8281 35.4324C18.9306 35.4742 19.0408 35.4951 19.1585 35.4951C19.2762 35.4951 19.3845 35.4742 19.4832 35.4324C19.582 35.3868 19.6674 35.3261 19.7396 35.2501C19.8117 35.1703 19.8668 35.0773 19.9048 34.9709C19.9466 34.8646 19.9675 34.7488 19.9675 34.6234V32.1794H20.8562V34.6576ZM21.6778 32.1794H23.2387C23.4438 32.1794 23.6375 32.2003 23.8198 32.2421C24.0059 32.2801 24.1674 32.3465 24.3041 32.4415C24.4446 32.5326 24.5547 32.658 24.6345 32.8175C24.7181 32.9732 24.7598 33.1688 24.7598 33.4043C24.7598 33.6891 24.6858 33.9322 24.5377 34.1335C24.3895 34.331 24.1731 34.4563 23.8882 34.5095L24.9137 36.2129H23.8483L23.0052 34.6006H22.5665V36.2129H21.6778V32.1794ZM22.5665 33.8486H23.0906C23.1704 33.8486 23.2539 33.8467 23.3413 33.8429C23.4324 33.8353 23.5141 33.8183 23.5863 33.7917C23.6584 33.7613 23.7173 33.7157 23.7629 33.6549C23.8122 33.5942 23.8369 33.5087 23.8369 33.3986C23.8369 33.296 23.816 33.2144 23.7743 33.1536C23.7325 33.0928 23.6793 33.0473 23.6147 33.0169C23.5502 32.9827 23.4761 32.9599 23.3926 32.9485C23.309 32.9371 23.2273 32.9314 23.1476 32.9314H22.5665V33.8486ZM25.4061 32.1794H28.1463V32.9998H26.2948V33.7518H28.0438V34.5722H26.2948V35.3925H28.2489V36.2129H25.4061V32.1794ZM28.9604 32.1794H30.2934C30.6163 32.1794 30.922 32.2155 31.2107 32.2877C31.5031 32.3598 31.7576 32.4776 31.9741 32.6409C32.1905 32.8004 32.3615 33.0093 32.4868 33.2675C32.6159 33.5258 32.6805 33.8391 32.6805 34.2075C32.6805 34.5342 32.6178 34.8228 32.4925 35.0735C32.371 35.3204 32.2057 35.5293 31.9968 35.7002C31.788 35.8673 31.5468 35.9945 31.2733 36.0819C30.9999 36.1692 30.7131 36.2129 30.4131 36.2129H28.9604V32.1794ZM29.8491 35.3925H30.3105C30.5156 35.3925 30.7055 35.3716 30.8802 35.3299C31.0587 35.2881 31.2126 35.2197 31.3417 35.1248C31.4708 35.026 31.5715 34.8988 31.6436 34.7431C31.7196 34.5836 31.7576 34.3899 31.7576 34.162C31.7576 33.9645 31.7196 33.7936 31.6436 33.6492C31.5715 33.5011 31.4727 33.3796 31.3474 33.2846C31.2221 33.1897 31.0739 33.1194 30.903 33.0738C30.7359 33.0245 30.5593 32.9998 30.3732 32.9998H29.8491V35.3925ZM34.9689 32.1794H36.4729C36.6476 32.1794 36.8223 32.1927 36.997 32.2193C37.1755 32.2421 37.3351 32.2915 37.4756 32.3674C37.6161 32.4396 37.73 32.5421 37.8174 32.6751C37.9048 32.808 37.9484 32.9846 37.9484 33.2049C37.9484 33.4328 37.8839 33.6227 37.7547 33.7746C37.6294 33.9227 37.4623 34.029 37.2534 34.0936V34.105C37.3863 34.124 37.506 34.162 37.6123 34.2189C37.7224 34.2721 37.8155 34.3424 37.8915 34.4297C37.9712 34.5133 38.032 34.612 38.0738 34.726C38.1155 34.8399 38.1364 34.9615 38.1364 35.0906C38.1364 35.3033 38.0909 35.4818 37.9997 35.6261C37.9085 35.7666 37.7908 35.8806 37.6465 35.9679C37.5022 36.0553 37.3388 36.1179 37.1565 36.1559C36.978 36.1939 36.7995 36.2129 36.621 36.2129H34.9689V32.1794ZM35.8576 33.7917H36.5014C36.5698 33.7917 36.6362 33.7841 36.7008 33.7689C36.7691 33.7537 36.8299 33.729 36.8831 33.6948C36.9363 33.6606 36.978 33.6151 37.0084 33.5581C37.0426 33.5011 37.0597 33.4328 37.0597 33.353C37.0597 33.2694 37.0407 33.2011 37.0027 33.1479C36.9685 33.0909 36.923 33.0473 36.866 33.0169C36.809 32.9865 36.7445 32.9656 36.6723 32.9542C36.6001 32.939 36.5299 32.9314 36.4615 32.9314H35.8576V33.7917ZM35.8576 35.4609H36.6552C36.7236 35.4609 36.7919 35.4533 36.8603 35.4381C36.9325 35.4229 36.997 35.3963 37.054 35.3583C37.111 35.3204 37.1565 35.271 37.1907 35.2102C37.2287 35.1495 37.2477 35.0754 37.2477 34.988C37.2477 34.8931 37.223 34.8171 37.1736 34.7602C37.1281 34.6994 37.0692 34.6538 36.997 34.6234C36.9249 34.593 36.847 34.5722 36.7635 34.5608C36.6799 34.5494 36.602 34.5437 36.5299 34.5437H35.8576V35.4609ZM39.6543 34.4924L38.1389 32.1794H39.2441L40.0987 33.6891L41.0045 32.1794H42.0585L40.5431 34.4924V36.2129H39.6543V34.4924ZM46.0369 33.165C45.9647 33.0738 45.866 33.0074 45.7406 32.9656C45.6191 32.92 45.5032 32.8972 45.3931 32.8972C45.3285 32.8972 45.2621 32.9048 45.1937 32.92C45.1253 32.9352 45.0608 32.9599 45 32.9941C44.9392 33.0245 44.8899 33.0663 44.8519 33.1194C44.8139 33.1726 44.7949 33.2372 44.7949 33.3131C44.7949 33.4347 44.8405 33.5277 44.9317 33.5923C45.0228 33.6568 45.1367 33.7119 45.2735 33.7575C45.414 33.8031 45.564 33.8486 45.7235 33.8942C45.883 33.9398 46.0312 34.0044 46.1679 34.0879C46.3084 34.1715 46.4243 34.2835 46.5154 34.424C46.6066 34.5646 46.6521 34.7526 46.6521 34.988C46.6521 35.2121 46.6104 35.4077 46.5268 35.5748C46.4433 35.7419 46.3293 35.8806 46.185 35.9907C46.0445 36.1008 45.8793 36.1825 45.6894 36.2357C45.5032 36.2889 45.3058 36.3154 45.0969 36.3154C44.8348 36.3154 44.5917 36.2756 44.3676 36.1958C44.1436 36.116 43.9347 35.9869 43.741 35.8084L44.3733 35.1134C44.4645 35.2349 44.5784 35.3299 44.7152 35.3982C44.8557 35.4628 45 35.4951 45.1481 35.4951C45.2203 35.4951 45.2925 35.4875 45.3646 35.4723C45.4406 35.4533 45.507 35.4267 45.564 35.3925C45.6248 35.3583 45.6723 35.3147 45.7064 35.2615C45.7444 35.2083 45.7634 35.1457 45.7634 35.0735C45.7634 34.952 45.7159 34.857 45.621 34.7886C45.5298 34.7165 45.414 34.6557 45.2735 34.6063C45.1329 34.557 44.981 34.5076 44.8177 34.4582C44.6544 34.4088 44.5025 34.3424 44.362 34.2588C44.2214 34.1753 44.1037 34.0651 44.0087 33.9284C43.9176 33.7917 43.872 33.6113 43.872 33.3872C43.872 33.1707 43.9138 32.9808 43.9973 32.8175C44.0847 32.6542 44.1986 32.5174 44.3392 32.4073C44.4835 32.2972 44.6487 32.2155 44.8348 32.1623C45.0209 32.1054 45.2127 32.0769 45.4102 32.0769C45.6381 32.0769 45.8584 32.1092 46.071 32.1737C46.2837 32.2383 46.4755 32.3465 46.6464 32.4985L46.0369 33.165ZM49.3082 33.165C49.236 33.0738 49.1373 33.0074 49.0119 32.9656C48.8904 32.92 48.7746 32.8972 48.6644 32.8972C48.5999 32.8972 48.5334 32.9048 48.465 32.92C48.3967 32.9352 48.3321 32.9599 48.2713 32.9941C48.2106 33.0245 48.1612 33.0663 48.1232 33.1194C48.0852 33.1726 48.0662 33.2372 48.0662 33.3131C48.0662 33.4347 48.1118 33.5277 48.203 33.5923C48.2941 33.6568 48.4081 33.7119 48.5448 33.7575C48.6853 33.8031 48.8353 33.8486 48.9949 33.8942C49.1544 33.9398 49.3025 34.0044 49.4392 34.0879C49.5797 34.1715 49.6956 34.2835 49.7867 34.424C49.8779 34.5646 49.9235 34.7526 49.9235 34.988C49.9235 35.2121 49.8817 35.4077 49.7981 35.5748C49.7146 35.7419 49.6006 35.8806 49.4563 35.9907C49.3158 36.1008 49.1506 36.1825 48.9607 36.2357C48.7746 36.2889 48.5771 36.3154 48.3682 36.3154C48.1061 36.3154 47.8631 36.2756 47.639 36.1958C47.4149 36.116 47.206 35.9869 47.0123 35.8084L47.6447 35.1134C47.7358 35.2349 47.8498 35.3299 47.9865 35.3982C48.127 35.4628 48.2713 35.4951 48.4195 35.4951C48.4916 35.4951 48.5638 35.4875 48.6359 35.4723C48.7119 35.4533 48.7784 35.4267 48.8353 35.3925C48.8961 35.3583 48.9436 35.3147 48.9778 35.2615C49.0157 35.2083 49.0347 35.1457 49.0347 35.0735C49.0347 34.952 48.9873 34.857 48.8923 34.7886C48.8012 34.7165 48.6853 34.6557 48.5448 34.6063C48.4043 34.557 48.2523 34.5076 48.089 34.4582C47.9257 34.4088 47.7738 34.3424 47.6333 34.2588C47.4927 34.1753 47.375 34.0651 47.2801 33.9284C47.1889 33.7917 47.1433 33.6113 47.1433 33.3872C47.1433 33.1707 47.1851 32.9808 47.2687 32.8175C47.356 32.6542 47.47 32.5174 47.6105 32.4073C47.7548 32.2972 47.92 32.2155 48.1061 32.1623C48.2922 32.1054 48.484 32.0769 48.6815 32.0769C48.9094 32.0769 49.1297 32.1092 49.3424 32.1737C49.5551 32.2383 49.7469 32.3465 49.9178 32.4985L49.3082 33.165ZM50.6197 32.1794H51.5085V35.3925H53.1549V36.2129H50.6197V32.1794Z" fill="white"/>
                <path d="M29.8424 28.5087C29.7253 28.5087 29.611 28.4831 29.5024 28.432C23.3825 25.5779 19.4282 19.668 19.4282 13.3777V8.06988C19.4282 7.83985 19.5282 7.61833 19.7054 7.46782C19.8796 7.3173 20.1139 7.24915 20.3425 7.28038C23.6082 7.74329 26.9453 6.63573 29.2767 4.32121C29.591 4.00882 30.0967 4.00882 30.411 4.32121C32.7424 6.63857 36.0795 7.74329 39.3452 7.28038C39.5738 7.24631 39.808 7.3173 39.9823 7.46782C40.1595 7.61833 40.2595 7.83985 40.2595 8.06988V13.3777C40.2595 19.668 36.3052 25.5779 30.1853 28.432C30.0767 28.4831 29.9624 28.5087 29.8453 28.5087H29.8424Z" fill="white"/>
                <path d="M33.7563 13.2924V11.7021C33.7563 9.55513 31.9991 7.80859 29.8392 7.80859C27.6792 7.80859 25.9221 9.55513 25.9221 11.7021V13.2924H24.5449V22.0138H35.1305V13.2924H33.7534H33.7563ZM27.8049 11.7759C27.8049 10.6599 28.7163 9.75393 29.8392 9.75393C30.402 9.75393 30.9106 9.98112 31.2791 10.3475C31.6477 10.7138 31.8763 11.2193 31.8763 11.7788V13.2953H27.8049V11.7788V11.7759ZM30.6706 17.8505V19.4011H29.0077V17.8505C28.822 17.6489 28.7077 17.3819 28.7077 17.0866C28.7077 16.4646 29.2135 15.962 29.8392 15.962C30.4649 15.962 30.9706 16.4646 30.9706 17.0866C30.9706 17.3819 30.8563 17.6489 30.6706 17.8505Z" fill="#006495"/>
              </svg>
            </div>
            <div  id="bbb_logo_container">
              <svg width="100%" height="100%" viewBox="0 0 113 43" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_4140_716)">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M5.93483 43.0002C2.89044 42.9946 0.389391 40.4935 0.383789 37.4492V6.26588C0.389391 3.22149 2.89044 0.720445 5.93483 0.714844H107.425C110.469 0.720445 112.97 3.22149 112.976 6.26588V37.4436C112.97 40.4879 110.469 42.989 107.425 42.9946H5.93483V43.0002Z" fill="#026495"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M5.93525 1.58203C3.36699 1.58763 1.25244 3.69938 1.25244 6.26484V37.4425C1.25804 40.0108 3.36979 42.1253 5.93525 42.1253H38.5497V1.58203H5.93525ZM82.7227 29.8021L83.4173 28.8247C83.9159 29.3456 84.6104 29.6397 85.333 29.6397C86.0556 29.6397 86.3805 29.3148 86.3805 28.9731C86.3805 28.5334 85.8203 28.4046 85.1594 28.2393C84.1707 28.0181 82.9132 27.7464 82.9132 26.3713C82.9132 25.3686 83.7814 24.5368 85.1986 24.5368C86.1592 24.5368 86.9518 24.8253 87.5484 25.377L86.8314 26.3152C86.3497 25.8867 85.7251 25.6543 85.0781 25.6599C84.5292 25.6599 84.2211 25.9035 84.2211 26.262C84.2211 26.6541 84.7757 26.7774 85.4198 26.9286C86.4085 27.1611 87.6772 27.4607 87.6772 28.8275C87.6772 29.9282 86.8902 30.76 85.2686 30.76C84.1119 30.7488 83.2773 30.3679 82.7227 29.7993V29.8021ZM77.2305 29.8021L77.9251 28.8247C78.4236 29.3456 79.1182 29.6397 79.8408 29.6397C80.5634 29.6397 80.8883 29.3148 80.8883 28.9731C80.8883 28.5334 80.3281 28.4046 79.6728 28.2393C78.6841 28.0181 77.4266 27.7464 77.4266 26.3713C77.4266 25.3686 78.2948 24.5368 79.712 24.5368C80.667 24.5368 81.4652 24.8253 82.0618 25.377L81.3504 26.3152C80.8687 25.8867 80.2441 25.6543 79.5971 25.6599C79.0482 25.6599 78.7401 25.9035 78.7401 26.262C78.7401 26.6541 79.2946 26.7774 79.9388 26.9286C80.9275 27.1611 82.1962 27.4607 82.1962 28.8275C82.1962 29.9282 81.4092 30.76 79.7876 30.76C78.6253 30.7488 77.7963 30.3679 77.2305 29.7993V29.8021ZM57.2305 29.8021L57.9251 28.8247C58.4236 29.3456 59.1182 29.6397 59.8408 29.6397C60.5634 29.6397 60.8883 29.3148 60.8883 28.9731C60.8883 28.5334 60.3281 28.4046 59.6672 28.2393C58.6785 28.0181 57.421 27.7464 57.421 26.3713C57.421 25.3686 58.2892 24.5368 59.7064 24.5368C60.667 24.5368 61.4596 24.8253 62.0562 25.377L61.3392 26.3152C60.8575 25.8867 60.2329 25.6543 59.5859 25.6599C59.037 25.6599 58.7289 25.9035 58.7289 26.262C58.7289 26.6541 59.2779 26.7774 59.9276 26.9286C60.9163 27.1611 62.185 27.4607 62.185 28.8275C62.185 29.9282 61.398 30.76 59.7764 30.76C58.6253 30.7488 57.7963 30.3679 57.2305 29.7993V29.8021ZM50.9457 28.2505V24.6264H52.2593V28.2029C52.2593 29.0431 52.7522 29.6201 53.6764 29.6201C54.6007 29.6201 55.088 29.0403 55.088 28.2029V24.6264H56.4015V28.2421C56.4015 29.7405 55.5165 30.76 53.682 30.76C51.8531 30.7656 50.9457 29.7349 50.9457 28.2533V28.2505ZM69.817 30.6536L66.9463 26.7241V30.6536H65.6663V24.6236H66.9799L69.775 28.4018V24.6236H71.0549V30.648H69.817V30.6536ZM63.1261 30.6536V24.6236H64.406V30.648H63.1261V30.6536ZM72.3068 30.6536V24.6236H76.5779V25.7523H73.5924V27.0266H76.5107V28.1553H73.5924V29.5165H76.5723V30.6452L72.3068 30.6508V30.6536ZM44.9017 30.6536V24.6236H48.0722C49.2233 24.6236 49.8086 25.3574 49.8086 26.1584C49.8086 26.9174 49.3353 27.4215 48.7723 27.542C49.4137 27.64 49.9234 28.2645 49.9234 29.0179C49.9234 29.9198 49.3213 30.6452 48.1702 30.6452L44.9045 30.6508L44.9017 30.6536ZM48.6127 28.8471C48.6127 28.4662 48.341 28.1413 47.8369 28.1413H46.1873V29.5417H47.8369C48.3186 29.5417 48.6127 29.2756 48.6127 28.8471ZM48.5007 26.3825C48.5007 26.0184 48.201 25.7271 47.8453 25.7271H46.1901V27.0406H47.7977C48.2318 27.0406 48.5035 26.769 48.5035 26.3881V26.3825H48.5007ZM50.8533 17.2941C50.8533 15.4428 52.2536 14.1741 54.0601 14.1741C55.1132 14.1461 56.0906 14.723 56.578 15.6501L55.4773 16.1934C55.2056 15.6669 54.6623 15.3252 54.0657 15.314C52.9762 15.314 52.178 16.1542 52.178 17.2829C52.178 18.4116 52.9706 19.2518 54.0657 19.2518C54.6623 19.2462 55.2112 18.9101 55.4829 18.378L56.578 18.9269C56.1439 19.6747 55.3849 20.4029 54.0601 20.4029C52.2592 20.4085 50.8533 19.1482 50.8533 17.2941ZM57.1241 17.2941C57.1241 15.4428 58.5245 14.1741 60.3309 14.1741C61.384 14.1461 62.3615 14.723 62.8488 15.6501L61.7481 16.1934C61.4708 15.6613 60.9275 15.3252 60.3309 15.314C59.2415 15.314 58.4433 16.1542 58.4433 17.2829C58.4433 18.4116 59.2359 19.2518 60.3309 19.2518C60.9275 19.2462 61.4764 18.9101 61.7481 18.378L62.8488 18.9101C62.4147 19.6579 61.6557 20.3861 60.3309 20.3861C58.5301 20.4085 57.1241 19.1482 57.1241 17.2941ZM67.0863 20.3049L65.9044 18.1707H64.9661V20.3049H63.6862V14.2805H66.5037C67.7585 14.2805 68.5287 15.1011 68.5287 16.2242C68.5287 17.2885 67.8621 17.8683 67.2151 18.0139L68.5707 20.3161L67.0891 20.3049H67.0863ZM49.058 20.3049L48.6883 19.2854H46.1061L45.7252 20.3049H44.2604L46.5934 14.2805H48.201L50.5228 20.3049H49.058ZM94.623 20.3049V14.2805H97.0008C98.8885 14.2805 100.196 15.4792 100.196 17.2969C100.196 19.1146 98.8829 20.3021 97.0008 20.3021H94.623V20.3049ZM89.2932 20.3049V14.2805H93.5644V15.4092H90.5732V16.6835H93.4887V17.8122H90.5732V19.1734H93.5531V20.3021H89.2932V20.3049ZM81.4344 20.3049V14.2805H82.7143V20.3049H81.4344ZM74.8863 20.3049V14.2805H77.2641C79.1518 14.2805 80.4598 15.4792 80.4598 17.2969C80.4598 19.1146 79.1462 20.3021 77.2641 20.3021H74.8863V20.3049ZM69.5565 20.3049V14.2805H73.8276V15.4092H70.8365V16.6835H73.7548V17.8122H70.8365V19.1734H73.8164V20.3021H69.5565V20.3049ZM85.3638 20.3049V15.4092H83.5994V14.2805H88.4082V15.4092H86.655V20.3049H85.3638ZM98.8941 17.2997C98.8941 16.2354 98.2388 15.412 97.0064 15.412H95.917V19.179H97.0064C98.1883 19.179 98.8829 18.322 98.8829 17.3025H98.8941V17.2997ZM79.1574 17.2997C79.1574 16.2354 78.502 15.412 77.2697 15.412H76.1802V19.179H77.2697C78.4516 19.179 79.1462 18.322 79.1462 17.3025H79.1574V17.2997ZM47.3972 15.5633L46.4589 18.1567H48.3354L47.3972 15.5633ZM67.2123 16.2186C67.2123 15.7145 66.8258 15.4036 66.3105 15.4036H64.9633V17.0308H66.3105C66.8258 17.0308 67.2123 16.7256 67.2123 16.2158V16.2186Z" fill="white"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M13.8746 35.5484C14.7316 35.9293 15.1489 36.1785 15.3113 37.2428C15.5886 39.0997 13.8774 39.8055 12.2669 39.8055H8.48877V31.7086H12.2978C13.6645 31.7086 14.9136 32.3331 14.9136 33.8567C14.9136 34.6157 14.5187 35.1703 13.8718 35.5512L13.8746 35.5484ZM21.4393 35.5484C22.2963 35.9293 22.7137 36.1785 22.8761 37.2428C23.1534 39.0997 21.4421 39.8055 19.8317 39.8055H16.0535V31.7086H19.8625C21.2293 31.7086 22.4784 32.3331 22.4784 33.8567C22.4784 34.6157 22.0835 35.1703 21.4365 35.5512L21.4393 35.5484ZM30.4437 37.2484C30.2812 36.1841 29.8583 35.9349 29.0069 35.554C29.6538 35.1731 30.0544 34.6213 30.0544 33.8567C30.0544 32.3331 28.8052 31.7086 27.4385 31.7086H23.6295V39.8111H27.4077C29.0153 39.8111 30.7293 39.1053 30.4465 37.2484H30.4437ZM31.4967 37.8646V37.8478C31.4967 36.8227 32.3369 35.9797 33.3648 35.9797C34.3927 35.9797 35.2329 36.8199 35.2329 37.8422V37.859C35.2329 38.884 34.3927 39.727 33.3648 39.727C32.3453 39.7326 31.5023 38.8924 31.4967 37.8646ZM35.0621 37.859V37.8422C35.0564 36.9151 34.2919 36.1477 33.3648 36.1477C32.4378 36.1477 31.6676 36.9123 31.6676 37.845V37.8618C31.6732 38.7888 32.4378 39.5562 33.3648 39.5562C34.2919 39.5562 35.0621 38.7916 35.0621 37.859ZM32.631 36.8451H33.488C33.6953 36.8339 33.8998 36.9095 34.0566 37.0468C34.1602 37.1448 34.2134 37.2792 34.2134 37.4164V37.4276C34.2134 37.7357 34.0062 37.9206 33.7205 37.9934L34.3115 38.7636H33.9586L33.404 38.041H32.9167V38.7636H32.6338L32.6282 36.8479L32.631 36.8451ZM12.4266 38.2735H10.2112V36.4278H12.4266C14.0482 36.4278 13.9502 38.2735 12.4266 38.2735ZM19.9913 38.2735H17.7816V36.4278H19.9913C21.613 36.4278 21.5149 38.2735 19.9913 38.2735ZM25.3463 36.4278V38.2735H27.5561C29.0797 38.2735 29.1777 36.4278 27.5561 36.4278H25.3463ZM33.46 37.7833C33.7261 37.7833 33.9166 37.6573 33.9166 37.4417V37.4305C33.9166 37.2288 33.7541 37.1 33.4768 37.1H32.9111V37.7833H33.46ZM10.2112 33.2518H12.1969C13.4349 33.2518 13.4769 34.977 12.2725 34.977H10.2112V33.2518ZM25.3519 33.2518H27.3208C28.5588 33.2518 28.6008 34.977 27.3965 34.977H25.3407L25.3519 33.2518ZM17.7872 33.2518H19.7673C21.0052 33.2518 21.0472 34.977 19.8429 34.977H17.7816L17.7872 33.2518ZM12.1493 28.0816H15.8351L16.4904 30.3166H22.5148L23.1702 28.0816H26.8559L26.3742 26.4376H12.6338L12.1521 28.0816H12.1493ZM16.6109 14.8342L14.8268 17.2988C13.9306 18.5312 14.2079 20.7185 15.429 21.598L18.7394 23.987C19.308 24.3987 19.3528 24.8076 19.0811 25.2361L19.5628 25.5946L21.2405 23.2728C22.2767 21.836 22.1843 19.8867 20.6495 18.7636L17.3055 16.327C16.9106 16.0329 16.8657 15.6268 17.0842 15.1759L16.6109 14.8398V14.8342ZM19.476 3.95898L16.6977 7.80718C15.3954 9.60805 15.8687 12.686 17.6471 13.9996L22.2179 17.3521C23.145 18.0298 23.2654 19.7663 22.5932 20.6513L22.9797 20.9454L26.1333 16.5118C27.5505 14.5205 27.4693 11.5742 25.2427 9.96094L20.3526 6.40682C19.6693 5.91389 19.3276 5.06527 19.8961 4.25866L19.4788 3.95898H19.476Z" fill="#026495"/>
                </g>
                <defs>
                <clipPath id="clip0_4140_716">
                <rect width="112.592" height="42.0306" fill="white" transform="translate(0.383789 0.680664)"/>
                </clipPath>
                </defs>
              </svg>
            </div>
            <div id="aplus_logo_container">
              <svg width="100%" height="100%" viewBox="0 0 44 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6.59916 30H1.39715L9.3235 7.03938H15.5794L23.4945 30H18.2925L12.5411 12.2862H12.3617L6.59916 30ZM6.27404 20.975H18.5616V24.7644H6.27404V20.975ZM30.1434 26.5021V10.627H34.1571V26.5021H30.1434ZM24.2127 20.5713V16.5577H40.0878V20.5713H24.2127Z" fill="#006495"/>
                <path d="M2.10261 43.4707V32.5032H5.64241C6.4207 32.5032 7.07047 32.6442 7.59171 32.9263C8.11652 33.2048 8.51102 33.5921 8.77521 34.0884C9.04297 34.581 9.17685 35.1469 9.17685 35.786C9.17685 36.425 9.04297 36.9891 8.77521 37.4782C8.51102 37.9673 8.1183 38.3493 7.59706 38.6242C7.07582 38.8991 6.42963 39.0366 5.65848 39.0366H2.64349V38.1208H5.6317C6.20292 38.1208 6.67775 38.0262 7.05619 37.837C7.43819 37.6478 7.72202 37.3783 7.90767 37.0284C8.09688 36.6785 8.19149 36.2644 8.19149 35.786C8.19149 35.3076 8.09688 34.8899 7.90767 34.5329C7.71845 34.1723 7.43284 33.8938 7.05083 33.6974C6.6724 33.5011 6.194 33.4029 5.61563 33.4029H3.10404V43.4707H2.10261ZM6.93837 38.5225L9.6374 43.4707H8.48067L5.80842 38.5225H6.93837ZM13.1122 43.6581C12.6159 43.6581 12.1625 43.5617 11.752 43.369C11.3414 43.1726 11.0147 42.8906 10.772 42.5228C10.5292 42.1515 10.4078 41.7017 10.4078 41.1733C10.4078 40.7663 10.4846 40.4236 10.6381 40.1451C10.7916 39.8666 11.0094 39.6382 11.2914 39.4596C11.5735 39.2811 11.9073 39.1401 12.2928 39.0366C12.6784 38.9331 13.1033 38.8527 13.5674 38.7956C14.0279 38.7385 14.4171 38.6885 14.7348 38.6457C15.0561 38.6028 15.3007 38.535 15.4685 38.4422C15.6363 38.3493 15.7202 38.1994 15.7202 37.9923V37.7995C15.7202 37.239 15.5524 36.7981 15.2168 36.4768C14.8848 36.1519 14.4064 35.9895 13.7816 35.9895C13.1889 35.9895 12.7052 36.1198 12.3303 36.3804C11.959 36.641 11.6984 36.9481 11.5485 37.3015L10.6434 36.9748C10.8291 36.525 11.0861 36.1662 11.4146 35.8984C11.743 35.6271 12.1108 35.4325 12.5178 35.3147C12.9248 35.1933 13.3371 35.1326 13.7548 35.1326C14.069 35.1326 14.3956 35.1737 14.7348 35.2558C15.0775 35.3379 15.3953 35.4807 15.688 35.6842C15.9808 35.8842 16.2182 36.1644 16.4003 36.525C16.5824 36.882 16.6734 37.3354 16.6734 37.8852V43.4707H15.7202V42.1694H15.6613C15.547 42.4122 15.3774 42.6478 15.1525 42.8763C14.9276 43.1048 14.6456 43.2922 14.3064 43.4386C13.9672 43.5849 13.5692 43.6581 13.1122 43.6581ZM13.2407 42.7852C13.7477 42.7852 14.1868 42.6728 14.5581 42.4479C14.9294 42.2229 15.215 41.9248 15.4149 41.5535C15.6184 41.1787 15.7202 40.7663 15.7202 40.3165V39.1276C15.6488 39.1955 15.5292 39.2562 15.3614 39.3097C15.1971 39.3633 15.0061 39.4115 14.7884 39.4543C14.5742 39.4936 14.3599 39.5275 14.1457 39.556C13.9315 39.5846 13.7387 39.6096 13.5674 39.631C13.1033 39.6881 12.707 39.7774 12.3785 39.8988C12.0501 40.0202 11.7984 40.188 11.6234 40.4022C11.4485 40.6128 11.361 40.8841 11.361 41.2162C11.361 41.716 11.5395 42.1033 11.8965 42.3782C12.2536 42.6496 12.7016 42.7852 13.2407 42.7852ZM21.8458 35.2451V36.0752H17.9204V35.2451H21.8458ZM19.1468 33.2744H20.1053V41.3233C20.1053 41.666 20.1642 41.9355 20.2821 42.1319C20.3999 42.3247 20.5534 42.4621 20.7426 42.5443C20.9318 42.6228 21.1335 42.6621 21.3478 42.6621C21.4727 42.6621 21.5798 42.6549 21.6691 42.6406C21.7583 42.6228 21.8369 42.6049 21.9047 42.5871L22.1082 43.4493C22.0154 43.485 21.9011 43.5171 21.7655 43.5457C21.6298 43.5778 21.462 43.5939 21.2621 43.5939C20.9122 43.5939 20.5748 43.5171 20.2499 43.3636C19.9286 43.2101 19.6644 42.9816 19.4574 42.6781C19.2503 42.3747 19.1468 41.998 19.1468 41.5482V33.2744ZM23.4181 43.4707V35.2451H24.3767V43.4707H23.4181ZM23.9055 33.8313C23.7091 33.8313 23.5413 33.7653 23.4021 33.6332C23.2628 33.4975 23.1932 33.3351 23.1932 33.1459C23.1932 32.9566 23.2628 32.796 23.4021 32.6639C23.5413 32.5282 23.7091 32.4604 23.9055 32.4604C24.1018 32.4604 24.2696 32.5282 24.4088 32.6639C24.5481 32.796 24.6177 32.9566 24.6177 33.1459C24.6177 33.3351 24.5481 33.4975 24.4088 33.6332C24.2696 33.7653 24.1018 33.8313 23.9055 33.8313ZM27.2477 38.3297V43.4707H26.2945V35.2451H27.2209V36.5357H27.3066C27.4994 36.1144 27.7993 35.777 28.2063 35.5236C28.6168 35.2665 29.1238 35.138 29.7272 35.138C30.2805 35.138 30.7661 35.254 31.1838 35.4861C31.6051 35.7146 31.9317 36.0519 32.1638 36.4982C32.3994 36.9445 32.5172 37.4925 32.5172 38.1423V43.4707H31.564V38.2012C31.564 37.5264 31.3748 36.9927 30.9963 36.6C30.6215 36.2072 30.1181 36.0109 29.4862 36.0109C29.0542 36.0109 28.6704 36.1037 28.3348 36.2894C27.9992 36.475 27.7332 36.7428 27.5369 37.0926C27.3441 37.4389 27.2477 37.8513 27.2477 38.3297ZM37.5624 46.7267C37.0019 46.7267 36.511 46.6535 36.0897 46.5071C35.6685 46.3643 35.3132 46.1679 35.0241 45.918C34.7349 45.6681 34.51 45.3879 34.3493 45.0773L35.1312 44.5632C35.249 44.7702 35.4061 44.9737 35.6024 45.1737C35.8023 45.3736 36.0612 45.5396 36.3789 45.6717C36.7002 45.8038 37.0947 45.8698 37.5624 45.8698C38.2907 45.8698 38.878 45.6878 39.3243 45.3236C39.7741 44.9595 39.999 44.3936 39.999 43.626V41.7731H39.9134C39.8027 42.023 39.6438 42.2729 39.4367 42.5228C39.2297 42.7692 38.9584 42.9745 38.6228 43.1387C38.2907 43.3029 37.8784 43.385 37.3857 43.385C36.7288 43.385 36.1451 43.2226 35.6345 42.8977C35.1276 42.5728 34.7277 42.1087 34.435 41.5053C34.1458 40.8984 34.0012 40.1755 34.0012 39.3365C34.0012 38.5046 34.1422 37.7728 34.4243 37.1408C34.7099 36.5089 35.108 36.0162 35.6185 35.6628C36.129 35.3094 36.7234 35.1326 37.4018 35.1326C37.9052 35.1326 38.3229 35.2219 38.6549 35.4004C38.9869 35.5753 39.2529 35.7931 39.4528 36.0537C39.6563 36.3144 39.8152 36.5678 39.9294 36.8142H40.0258V35.2451H40.9576V43.6849C40.9576 44.3811 40.8095 44.9541 40.5131 45.4039C40.2168 45.8538 39.8134 46.1858 39.3029 46.4C38.7923 46.6178 38.2122 46.7267 37.5624 46.7267ZM37.4982 42.5121C38.0265 42.5121 38.4782 42.3854 38.853 42.1319C39.2279 41.8748 39.5153 41.5071 39.7152 41.0287C39.9151 40.5503 40.0151 39.9809 40.0151 39.3204C40.0151 38.6778 39.9169 38.1083 39.7206 37.6121C39.5242 37.1123 39.2386 36.7196 38.8637 36.434C38.4924 36.1448 38.0373 36.0002 37.4982 36.0002C36.9484 36.0002 36.4842 36.1483 36.1058 36.4447C35.7274 36.741 35.4418 37.1408 35.249 37.6442C35.0562 38.1441 34.9598 38.7028 34.9598 39.3204C34.9598 39.9488 35.058 40.5039 35.2543 40.9859C35.4507 41.4643 35.7381 41.8391 36.1165 42.1105C36.495 42.3782 36.9555 42.5121 37.4982 42.5121Z" fill="#006495"/>
              </svg>
            </div>
          </div>
        </div>
        <div class="column" id="app-column">
          <!-- <div>Progress {{ progress }}%</div> -->
          <div id="progress-bar-main-container"  class="desktop_container">
            <div style="display: inline;">
              <div id="progress-bar-container">
                <div style="display: inline;">
                  <div class="progress-bar" :style="{ width: progress_css + '%' }"></div>
                </div>
                <div id="progress_bar_point_container"  :style="{ left: progress_css + '%' }">
                  <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
                  <path d="M11.8779 6.02222C11.8779 8.79941 9.63587 11.0444 6.87793 11.0444C4.11999 11.0444 1.87793 8.79941 1.87793 6.02222C1.87793 3.24504 4.11999 1 6.87793 1C9.63587 1 11.8779 3.24504 11.8779 6.02222Z" fill="#28A745" stroke="#F1F1F1" stroke-width="2"/>
                  </svg>
                </div>
              </div>
            </div>
            <div style="text-align: right;" id="progress-label">
              <span v-if="this.page < 5">{{ this.page+1 }}/{{ this.maxCompleteApp }}</span>
              <span v-else>5/5</span>
            </div>
          </div>
          <div id="transition_container">
            <div
            id=""
            style="max-width: 600px; margin: auto"
            :class="scrolled ? 'pushed-pages' : ''"
            v-if="!loading"
          >
            <transition name="slide" mode="out-in">
              <GetStarted
                v-if="page == 0 && !loading"
                key="p0"
                @next="incrementPage"
                :amt="$route.params.amt"
              />
              <BusinessInfo 
                v-if="page == 1" 
                key="p1" 
                @next="incrementPage" 
              />
              <IFF
                v-if="page == 2"
                key="p2"
                api="apply"
                @next="incrementPage"
                :link="model.sfleadid"
                :lang="language"
              />
              <VerifyOwnership
                v-if="page == 3"
                key="p3"
                @next="incrementPage"
                :lang="language"
              />
              <BusinessAddressIFF
                v-if="page == 4"
                key="p4"
                @next="incrementPage"
                :lang="language"
              />
              <BankVerify
                v-if="page == 5"
                key="p5"
                @next="incrementPage"
                message="To provide an instant approval, we need to verify your business bank account information."
              />
              <Plaid
                v-if="page == 6"
                key="p6"
                @next="incrementPage"
                api="plaid"
                redirect_url="apply"
              />
              <PlaidResult
                v-if="page == 7"
                key="p7"
                api="apply"
                @next="incrementPage"
                :itemid="item_id"
                @back="sendPlaidPage"
                :link="model.sfleadid"
              />
              <UploadDoc
                v-if="page == 8"
                key="p8"
                @next="incrementPage"
                doc="Photo ID"
                api="apply"
                :link="model.sfleadid"
              />
              <UploadDoc
                v-if="page == 9"
                key="p9"
                @next="incrementPage"
                doc="Voided Check"
                api="apply"
                :link="model.sfleadid"
              />
              <ApprovalApply
                v-if="page == 10"
                key="p10"
                title="Great news you're qualified!"
                :texts="finishText"
                :link="model.sfleadid"
              />
            </transition>
            </div>
          </div> 
          <div
            style="max-width: 600px; margin: auto"
            :class="scrolled ? 'pushed-pages' : ''"
            v-if="loading"
          >
            <a
              class="button is-link is-loading is-large is-fullwidth"
              key="loading"
              >Loading</a
            >
          </div>
        </div>
      </div>
    </div>
    <footer
      class="footer mobile-only"
      v-if="page != 6"
    >
      <div class="content has-text-centered">
        <div id="logos-container">
          <div id="ssl_logo_container">
            <svg width="100%" height="100%" viewBox="0 0 60 43" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect y="0.680664" width="59.7138" height="42.0306" rx="4.27275" fill="#006495"/>
              <path d="M8.68929 33.165C8.61713 33.0738 8.51838 33.0074 8.39304 32.9656C8.27151 32.92 8.15567 32.8972 8.04553 32.8972C7.98096 32.8972 7.9145 32.9048 7.84613 32.92C7.77777 32.9352 7.7132 32.9599 7.65243 32.9941C7.59167 33.0245 7.54229 33.0663 7.50431 33.1194C7.46633 33.1726 7.44734 33.2372 7.44734 33.3131C7.44734 33.4347 7.49292 33.5277 7.58407 33.5923C7.67522 33.6568 7.78916 33.7119 7.92589 33.7575C8.06642 33.8031 8.21644 33.8486 8.37595 33.8942C8.53547 33.9398 8.68359 34.0044 8.82032 34.0879C8.96084 34.1715 9.07668 34.2835 9.16784 34.424C9.25899 34.5646 9.30456 34.7526 9.30456 34.988C9.30456 35.2121 9.26279 35.4077 9.17923 35.5748C9.09567 35.7419 8.98173 35.8806 8.83741 35.9907C8.69688 36.1008 8.53167 36.1825 8.34177 36.2357C8.15567 36.2889 7.95817 36.3154 7.74928 36.3154C7.48722 36.3154 7.24415 36.2756 7.02007 36.1958C6.79599 36.116 6.5871 35.9869 6.3934 35.8084L7.02577 35.1134C7.11692 35.2349 7.23086 35.3299 7.36759 35.3982C7.50811 35.4628 7.65243 35.4951 7.80056 35.4951C7.87272 35.4951 7.94488 35.4875 8.01704 35.4723C8.093 35.4533 8.15947 35.4267 8.21644 35.3925C8.27721 35.3583 8.32468 35.3147 8.35886 35.2615C8.39684 35.2083 8.41583 35.1457 8.41583 35.0735C8.41583 34.952 8.36836 34.857 8.27341 34.7886C8.18226 34.7165 8.06642 34.6557 7.92589 34.6063C7.78536 34.557 7.63344 34.5076 7.47013 34.4582C7.30682 34.4088 7.1549 34.3424 7.01437 34.2588C6.87385 34.1753 6.75611 34.0651 6.66116 33.9284C6.57001 33.7917 6.52443 33.6113 6.52443 33.3872C6.52443 33.1707 6.56621 32.9808 6.64976 32.8175C6.73712 32.6542 6.85106 32.5174 6.99158 32.4073C7.13591 32.2972 7.30112 32.2155 7.48722 32.1623C7.67332 32.1054 7.86512 32.0769 8.06262 32.0769C8.2905 32.0769 8.51078 32.1092 8.72347 32.1737C8.93616 32.2383 9.12796 32.3465 9.29887 32.4985L8.68929 33.165ZM10.0008 32.1794H12.7411V32.9998H10.8896V33.7518H12.6386V34.5722H10.8896V35.3925H12.8436V36.2129H10.0008V32.1794ZM16.1928 33.2277C16.1055 33.1213 15.9972 33.0397 15.8681 32.9827C15.7427 32.9257 15.5965 32.8972 15.4294 32.8972C15.2623 32.8972 15.1066 32.9295 14.9623 32.9941C14.8217 33.0587 14.6983 33.1498 14.592 33.2675C14.4894 33.3815 14.4077 33.5182 14.347 33.6777C14.29 33.8372 14.2615 34.0101 14.2615 34.1962C14.2615 34.3861 14.29 34.5608 14.347 34.7203C14.4077 34.876 14.4894 35.0127 14.592 35.1305C14.6945 35.2444 14.8141 35.3337 14.9509 35.3982C15.0914 35.4628 15.2414 35.4951 15.4009 35.4951C15.5832 35.4951 15.7446 35.4571 15.8852 35.3811C16.0257 35.3052 16.1415 35.1988 16.2327 35.0621L16.9733 35.6147C16.8024 35.854 16.5859 36.0306 16.3238 36.1445C16.0618 36.2585 15.7921 36.3154 15.5149 36.3154C15.1996 36.3154 14.9091 36.2661 14.6432 36.1673C14.3774 36.0686 14.1476 35.928 13.9539 35.7457C13.7602 35.5596 13.6083 35.3356 13.4981 35.0735C13.3918 34.8114 13.3386 34.519 13.3386 34.1962C13.3386 33.8733 13.3918 33.5809 13.4981 33.3188C13.6083 33.0568 13.7602 32.8346 13.9539 32.6523C14.1476 32.4662 14.3774 32.3237 14.6432 32.225C14.9091 32.1262 15.1996 32.0769 15.5149 32.0769C15.6288 32.0769 15.7465 32.0883 15.8681 32.1111C15.9934 32.13 16.1149 32.1623 16.2327 32.2079C16.3542 32.2535 16.4701 32.3142 16.5802 32.3902C16.6903 32.4662 16.7891 32.5592 16.8764 32.6694L16.1928 33.2277ZM20.8562 34.6576C20.8562 34.8969 20.8201 35.1172 20.748 35.3185C20.6758 35.5198 20.5676 35.6945 20.4232 35.8426C20.2827 35.9907 20.1061 36.1065 19.8934 36.1901C19.6807 36.2737 19.4357 36.3154 19.1585 36.3154C18.8774 36.3154 18.6306 36.2737 18.4179 36.1901C18.2052 36.1065 18.0267 35.9907 17.8824 35.8426C17.7418 35.6945 17.6355 35.5198 17.5633 35.3185C17.4912 35.1172 17.4551 34.8969 17.4551 34.6576V32.1794H18.3438V34.6234C18.3438 34.7488 18.3628 34.8646 18.4008 34.9709C18.4426 35.0773 18.4995 35.1703 18.5717 35.2501C18.6439 35.3261 18.7293 35.3868 18.8281 35.4324C18.9306 35.4742 19.0408 35.4951 19.1585 35.4951C19.2762 35.4951 19.3845 35.4742 19.4832 35.4324C19.582 35.3868 19.6674 35.3261 19.7396 35.2501C19.8117 35.1703 19.8668 35.0773 19.9048 34.9709C19.9466 34.8646 19.9675 34.7488 19.9675 34.6234V32.1794H20.8562V34.6576ZM21.6778 32.1794H23.2387C23.4438 32.1794 23.6375 32.2003 23.8198 32.2421C24.0059 32.2801 24.1674 32.3465 24.3041 32.4415C24.4446 32.5326 24.5547 32.658 24.6345 32.8175C24.7181 32.9732 24.7598 33.1688 24.7598 33.4043C24.7598 33.6891 24.6858 33.9322 24.5377 34.1335C24.3895 34.331 24.1731 34.4563 23.8882 34.5095L24.9137 36.2129H23.8483L23.0052 34.6006H22.5665V36.2129H21.6778V32.1794ZM22.5665 33.8486H23.0906C23.1704 33.8486 23.2539 33.8467 23.3413 33.8429C23.4324 33.8353 23.5141 33.8183 23.5863 33.7917C23.6584 33.7613 23.7173 33.7157 23.7629 33.6549C23.8122 33.5942 23.8369 33.5087 23.8369 33.3986C23.8369 33.296 23.816 33.2144 23.7743 33.1536C23.7325 33.0928 23.6793 33.0473 23.6147 33.0169C23.5502 32.9827 23.4761 32.9599 23.3926 32.9485C23.309 32.9371 23.2273 32.9314 23.1476 32.9314H22.5665V33.8486ZM25.4061 32.1794H28.1463V32.9998H26.2948V33.7518H28.0438V34.5722H26.2948V35.3925H28.2489V36.2129H25.4061V32.1794ZM28.9604 32.1794H30.2934C30.6163 32.1794 30.922 32.2155 31.2107 32.2877C31.5031 32.3598 31.7576 32.4776 31.9741 32.6409C32.1905 32.8004 32.3615 33.0093 32.4868 33.2675C32.6159 33.5258 32.6805 33.8391 32.6805 34.2075C32.6805 34.5342 32.6178 34.8228 32.4925 35.0735C32.371 35.3204 32.2057 35.5293 31.9968 35.7002C31.788 35.8673 31.5468 35.9945 31.2733 36.0819C30.9999 36.1692 30.7131 36.2129 30.4131 36.2129H28.9604V32.1794ZM29.8491 35.3925H30.3105C30.5156 35.3925 30.7055 35.3716 30.8802 35.3299C31.0587 35.2881 31.2126 35.2197 31.3417 35.1248C31.4708 35.026 31.5715 34.8988 31.6436 34.7431C31.7196 34.5836 31.7576 34.3899 31.7576 34.162C31.7576 33.9645 31.7196 33.7936 31.6436 33.6492C31.5715 33.5011 31.4727 33.3796 31.3474 33.2846C31.2221 33.1897 31.0739 33.1194 30.903 33.0738C30.7359 33.0245 30.5593 32.9998 30.3732 32.9998H29.8491V35.3925ZM34.9689 32.1794H36.4729C36.6476 32.1794 36.8223 32.1927 36.997 32.2193C37.1755 32.2421 37.3351 32.2915 37.4756 32.3674C37.6161 32.4396 37.73 32.5421 37.8174 32.6751C37.9048 32.808 37.9484 32.9846 37.9484 33.2049C37.9484 33.4328 37.8839 33.6227 37.7547 33.7746C37.6294 33.9227 37.4623 34.029 37.2534 34.0936V34.105C37.3863 34.124 37.506 34.162 37.6123 34.2189C37.7224 34.2721 37.8155 34.3424 37.8915 34.4297C37.9712 34.5133 38.032 34.612 38.0738 34.726C38.1155 34.8399 38.1364 34.9615 38.1364 35.0906C38.1364 35.3033 38.0909 35.4818 37.9997 35.6261C37.9085 35.7666 37.7908 35.8806 37.6465 35.9679C37.5022 36.0553 37.3388 36.1179 37.1565 36.1559C36.978 36.1939 36.7995 36.2129 36.621 36.2129H34.9689V32.1794ZM35.8576 33.7917H36.5014C36.5698 33.7917 36.6362 33.7841 36.7008 33.7689C36.7691 33.7537 36.8299 33.729 36.8831 33.6948C36.9363 33.6606 36.978 33.6151 37.0084 33.5581C37.0426 33.5011 37.0597 33.4328 37.0597 33.353C37.0597 33.2694 37.0407 33.2011 37.0027 33.1479C36.9685 33.0909 36.923 33.0473 36.866 33.0169C36.809 32.9865 36.7445 32.9656 36.6723 32.9542C36.6001 32.939 36.5299 32.9314 36.4615 32.9314H35.8576V33.7917ZM35.8576 35.4609H36.6552C36.7236 35.4609 36.7919 35.4533 36.8603 35.4381C36.9325 35.4229 36.997 35.3963 37.054 35.3583C37.111 35.3204 37.1565 35.271 37.1907 35.2102C37.2287 35.1495 37.2477 35.0754 37.2477 34.988C37.2477 34.8931 37.223 34.8171 37.1736 34.7602C37.1281 34.6994 37.0692 34.6538 36.997 34.6234C36.9249 34.593 36.847 34.5722 36.7635 34.5608C36.6799 34.5494 36.602 34.5437 36.5299 34.5437H35.8576V35.4609ZM39.6543 34.4924L38.1389 32.1794H39.2441L40.0987 33.6891L41.0045 32.1794H42.0585L40.5431 34.4924V36.2129H39.6543V34.4924ZM46.0369 33.165C45.9647 33.0738 45.866 33.0074 45.7406 32.9656C45.6191 32.92 45.5032 32.8972 45.3931 32.8972C45.3285 32.8972 45.2621 32.9048 45.1937 32.92C45.1253 32.9352 45.0608 32.9599 45 32.9941C44.9392 33.0245 44.8899 33.0663 44.8519 33.1194C44.8139 33.1726 44.7949 33.2372 44.7949 33.3131C44.7949 33.4347 44.8405 33.5277 44.9317 33.5923C45.0228 33.6568 45.1367 33.7119 45.2735 33.7575C45.414 33.8031 45.564 33.8486 45.7235 33.8942C45.883 33.9398 46.0312 34.0044 46.1679 34.0879C46.3084 34.1715 46.4243 34.2835 46.5154 34.424C46.6066 34.5646 46.6521 34.7526 46.6521 34.988C46.6521 35.2121 46.6104 35.4077 46.5268 35.5748C46.4433 35.7419 46.3293 35.8806 46.185 35.9907C46.0445 36.1008 45.8793 36.1825 45.6894 36.2357C45.5032 36.2889 45.3058 36.3154 45.0969 36.3154C44.8348 36.3154 44.5917 36.2756 44.3676 36.1958C44.1436 36.116 43.9347 35.9869 43.741 35.8084L44.3733 35.1134C44.4645 35.2349 44.5784 35.3299 44.7152 35.3982C44.8557 35.4628 45 35.4951 45.1481 35.4951C45.2203 35.4951 45.2925 35.4875 45.3646 35.4723C45.4406 35.4533 45.507 35.4267 45.564 35.3925C45.6248 35.3583 45.6723 35.3147 45.7064 35.2615C45.7444 35.2083 45.7634 35.1457 45.7634 35.0735C45.7634 34.952 45.7159 34.857 45.621 34.7886C45.5298 34.7165 45.414 34.6557 45.2735 34.6063C45.1329 34.557 44.981 34.5076 44.8177 34.4582C44.6544 34.4088 44.5025 34.3424 44.362 34.2588C44.2214 34.1753 44.1037 34.0651 44.0087 33.9284C43.9176 33.7917 43.872 33.6113 43.872 33.3872C43.872 33.1707 43.9138 32.9808 43.9973 32.8175C44.0847 32.6542 44.1986 32.5174 44.3392 32.4073C44.4835 32.2972 44.6487 32.2155 44.8348 32.1623C45.0209 32.1054 45.2127 32.0769 45.4102 32.0769C45.6381 32.0769 45.8584 32.1092 46.071 32.1737C46.2837 32.2383 46.4755 32.3465 46.6464 32.4985L46.0369 33.165ZM49.3082 33.165C49.236 33.0738 49.1373 33.0074 49.0119 32.9656C48.8904 32.92 48.7746 32.8972 48.6644 32.8972C48.5999 32.8972 48.5334 32.9048 48.465 32.92C48.3967 32.9352 48.3321 32.9599 48.2713 32.9941C48.2106 33.0245 48.1612 33.0663 48.1232 33.1194C48.0852 33.1726 48.0662 33.2372 48.0662 33.3131C48.0662 33.4347 48.1118 33.5277 48.203 33.5923C48.2941 33.6568 48.4081 33.7119 48.5448 33.7575C48.6853 33.8031 48.8353 33.8486 48.9949 33.8942C49.1544 33.9398 49.3025 34.0044 49.4392 34.0879C49.5797 34.1715 49.6956 34.2835 49.7867 34.424C49.8779 34.5646 49.9235 34.7526 49.9235 34.988C49.9235 35.2121 49.8817 35.4077 49.7981 35.5748C49.7146 35.7419 49.6006 35.8806 49.4563 35.9907C49.3158 36.1008 49.1506 36.1825 48.9607 36.2357C48.7746 36.2889 48.5771 36.3154 48.3682 36.3154C48.1061 36.3154 47.8631 36.2756 47.639 36.1958C47.4149 36.116 47.206 35.9869 47.0123 35.8084L47.6447 35.1134C47.7358 35.2349 47.8498 35.3299 47.9865 35.3982C48.127 35.4628 48.2713 35.4951 48.4195 35.4951C48.4916 35.4951 48.5638 35.4875 48.6359 35.4723C48.7119 35.4533 48.7784 35.4267 48.8353 35.3925C48.8961 35.3583 48.9436 35.3147 48.9778 35.2615C49.0157 35.2083 49.0347 35.1457 49.0347 35.0735C49.0347 34.952 48.9873 34.857 48.8923 34.7886C48.8012 34.7165 48.6853 34.6557 48.5448 34.6063C48.4043 34.557 48.2523 34.5076 48.089 34.4582C47.9257 34.4088 47.7738 34.3424 47.6333 34.2588C47.4927 34.1753 47.375 34.0651 47.2801 33.9284C47.1889 33.7917 47.1433 33.6113 47.1433 33.3872C47.1433 33.1707 47.1851 32.9808 47.2687 32.8175C47.356 32.6542 47.47 32.5174 47.6105 32.4073C47.7548 32.2972 47.92 32.2155 48.1061 32.1623C48.2922 32.1054 48.484 32.0769 48.6815 32.0769C48.9094 32.0769 49.1297 32.1092 49.3424 32.1737C49.5551 32.2383 49.7469 32.3465 49.9178 32.4985L49.3082 33.165ZM50.6197 32.1794H51.5085V35.3925H53.1549V36.2129H50.6197V32.1794Z" fill="white"/>
              <path d="M29.8424 28.5087C29.7253 28.5087 29.611 28.4831 29.5024 28.432C23.3825 25.5779 19.4282 19.668 19.4282 13.3777V8.06988C19.4282 7.83985 19.5282 7.61833 19.7054 7.46782C19.8796 7.3173 20.1139 7.24915 20.3425 7.28038C23.6082 7.74329 26.9453 6.63573 29.2767 4.32121C29.591 4.00882 30.0967 4.00882 30.411 4.32121C32.7424 6.63857 36.0795 7.74329 39.3452 7.28038C39.5738 7.24631 39.808 7.3173 39.9823 7.46782C40.1595 7.61833 40.2595 7.83985 40.2595 8.06988V13.3777C40.2595 19.668 36.3052 25.5779 30.1853 28.432C30.0767 28.4831 29.9624 28.5087 29.8453 28.5087H29.8424Z" fill="white"/>
              <path d="M33.7563 13.2924V11.7021C33.7563 9.55513 31.9991 7.80859 29.8392 7.80859C27.6792 7.80859 25.9221 9.55513 25.9221 11.7021V13.2924H24.5449V22.0138H35.1305V13.2924H33.7534H33.7563ZM27.8049 11.7759C27.8049 10.6599 28.7163 9.75393 29.8392 9.75393C30.402 9.75393 30.9106 9.98112 31.2791 10.3475C31.6477 10.7138 31.8763 11.2193 31.8763 11.7788V13.2953H27.8049V11.7788V11.7759ZM30.6706 17.8505V19.4011H29.0077V17.8505C28.822 17.6489 28.7077 17.3819 28.7077 17.0866C28.7077 16.4646 29.2135 15.962 29.8392 15.962C30.4649 15.962 30.9706 16.4646 30.9706 17.0866C30.9706 17.3819 30.8563 17.6489 30.6706 17.8505Z" fill="#006495"/>
            </svg>
          </div>
          <div  id="bbb_logo_container">
            <svg width="100%" height="100%" viewBox="0 0 113 43" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_4140_716)">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M5.93483 43.0002C2.89044 42.9946 0.389391 40.4935 0.383789 37.4492V6.26588C0.389391 3.22149 2.89044 0.720445 5.93483 0.714844H107.425C110.469 0.720445 112.97 3.22149 112.976 6.26588V37.4436C112.97 40.4879 110.469 42.989 107.425 42.9946H5.93483V43.0002Z" fill="#026495"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M5.93525 1.58203C3.36699 1.58763 1.25244 3.69938 1.25244 6.26484V37.4425C1.25804 40.0108 3.36979 42.1253 5.93525 42.1253H38.5497V1.58203H5.93525ZM82.7227 29.8021L83.4173 28.8247C83.9159 29.3456 84.6104 29.6397 85.333 29.6397C86.0556 29.6397 86.3805 29.3148 86.3805 28.9731C86.3805 28.5334 85.8203 28.4046 85.1594 28.2393C84.1707 28.0181 82.9132 27.7464 82.9132 26.3713C82.9132 25.3686 83.7814 24.5368 85.1986 24.5368C86.1592 24.5368 86.9518 24.8253 87.5484 25.377L86.8314 26.3152C86.3497 25.8867 85.7251 25.6543 85.0781 25.6599C84.5292 25.6599 84.2211 25.9035 84.2211 26.262C84.2211 26.6541 84.7757 26.7774 85.4198 26.9286C86.4085 27.1611 87.6772 27.4607 87.6772 28.8275C87.6772 29.9282 86.8902 30.76 85.2686 30.76C84.1119 30.7488 83.2773 30.3679 82.7227 29.7993V29.8021ZM77.2305 29.8021L77.9251 28.8247C78.4236 29.3456 79.1182 29.6397 79.8408 29.6397C80.5634 29.6397 80.8883 29.3148 80.8883 28.9731C80.8883 28.5334 80.3281 28.4046 79.6728 28.2393C78.6841 28.0181 77.4266 27.7464 77.4266 26.3713C77.4266 25.3686 78.2948 24.5368 79.712 24.5368C80.667 24.5368 81.4652 24.8253 82.0618 25.377L81.3504 26.3152C80.8687 25.8867 80.2441 25.6543 79.5971 25.6599C79.0482 25.6599 78.7401 25.9035 78.7401 26.262C78.7401 26.6541 79.2946 26.7774 79.9388 26.9286C80.9275 27.1611 82.1962 27.4607 82.1962 28.8275C82.1962 29.9282 81.4092 30.76 79.7876 30.76C78.6253 30.7488 77.7963 30.3679 77.2305 29.7993V29.8021ZM57.2305 29.8021L57.9251 28.8247C58.4236 29.3456 59.1182 29.6397 59.8408 29.6397C60.5634 29.6397 60.8883 29.3148 60.8883 28.9731C60.8883 28.5334 60.3281 28.4046 59.6672 28.2393C58.6785 28.0181 57.421 27.7464 57.421 26.3713C57.421 25.3686 58.2892 24.5368 59.7064 24.5368C60.667 24.5368 61.4596 24.8253 62.0562 25.377L61.3392 26.3152C60.8575 25.8867 60.2329 25.6543 59.5859 25.6599C59.037 25.6599 58.7289 25.9035 58.7289 26.262C58.7289 26.6541 59.2779 26.7774 59.9276 26.9286C60.9163 27.1611 62.185 27.4607 62.185 28.8275C62.185 29.9282 61.398 30.76 59.7764 30.76C58.6253 30.7488 57.7963 30.3679 57.2305 29.7993V29.8021ZM50.9457 28.2505V24.6264H52.2593V28.2029C52.2593 29.0431 52.7522 29.6201 53.6764 29.6201C54.6007 29.6201 55.088 29.0403 55.088 28.2029V24.6264H56.4015V28.2421C56.4015 29.7405 55.5165 30.76 53.682 30.76C51.8531 30.7656 50.9457 29.7349 50.9457 28.2533V28.2505ZM69.817 30.6536L66.9463 26.7241V30.6536H65.6663V24.6236H66.9799L69.775 28.4018V24.6236H71.0549V30.648H69.817V30.6536ZM63.1261 30.6536V24.6236H64.406V30.648H63.1261V30.6536ZM72.3068 30.6536V24.6236H76.5779V25.7523H73.5924V27.0266H76.5107V28.1553H73.5924V29.5165H76.5723V30.6452L72.3068 30.6508V30.6536ZM44.9017 30.6536V24.6236H48.0722C49.2233 24.6236 49.8086 25.3574 49.8086 26.1584C49.8086 26.9174 49.3353 27.4215 48.7723 27.542C49.4137 27.64 49.9234 28.2645 49.9234 29.0179C49.9234 29.9198 49.3213 30.6452 48.1702 30.6452L44.9045 30.6508L44.9017 30.6536ZM48.6127 28.8471C48.6127 28.4662 48.341 28.1413 47.8369 28.1413H46.1873V29.5417H47.8369C48.3186 29.5417 48.6127 29.2756 48.6127 28.8471ZM48.5007 26.3825C48.5007 26.0184 48.201 25.7271 47.8453 25.7271H46.1901V27.0406H47.7977C48.2318 27.0406 48.5035 26.769 48.5035 26.3881V26.3825H48.5007ZM50.8533 17.2941C50.8533 15.4428 52.2536 14.1741 54.0601 14.1741C55.1132 14.1461 56.0906 14.723 56.578 15.6501L55.4773 16.1934C55.2056 15.6669 54.6623 15.3252 54.0657 15.314C52.9762 15.314 52.178 16.1542 52.178 17.2829C52.178 18.4116 52.9706 19.2518 54.0657 19.2518C54.6623 19.2462 55.2112 18.9101 55.4829 18.378L56.578 18.9269C56.1439 19.6747 55.3849 20.4029 54.0601 20.4029C52.2592 20.4085 50.8533 19.1482 50.8533 17.2941ZM57.1241 17.2941C57.1241 15.4428 58.5245 14.1741 60.3309 14.1741C61.384 14.1461 62.3615 14.723 62.8488 15.6501L61.7481 16.1934C61.4708 15.6613 60.9275 15.3252 60.3309 15.314C59.2415 15.314 58.4433 16.1542 58.4433 17.2829C58.4433 18.4116 59.2359 19.2518 60.3309 19.2518C60.9275 19.2462 61.4764 18.9101 61.7481 18.378L62.8488 18.9101C62.4147 19.6579 61.6557 20.3861 60.3309 20.3861C58.5301 20.4085 57.1241 19.1482 57.1241 17.2941ZM67.0863 20.3049L65.9044 18.1707H64.9661V20.3049H63.6862V14.2805H66.5037C67.7585 14.2805 68.5287 15.1011 68.5287 16.2242C68.5287 17.2885 67.8621 17.8683 67.2151 18.0139L68.5707 20.3161L67.0891 20.3049H67.0863ZM49.058 20.3049L48.6883 19.2854H46.1061L45.7252 20.3049H44.2604L46.5934 14.2805H48.201L50.5228 20.3049H49.058ZM94.623 20.3049V14.2805H97.0008C98.8885 14.2805 100.196 15.4792 100.196 17.2969C100.196 19.1146 98.8829 20.3021 97.0008 20.3021H94.623V20.3049ZM89.2932 20.3049V14.2805H93.5644V15.4092H90.5732V16.6835H93.4887V17.8122H90.5732V19.1734H93.5531V20.3021H89.2932V20.3049ZM81.4344 20.3049V14.2805H82.7143V20.3049H81.4344ZM74.8863 20.3049V14.2805H77.2641C79.1518 14.2805 80.4598 15.4792 80.4598 17.2969C80.4598 19.1146 79.1462 20.3021 77.2641 20.3021H74.8863V20.3049ZM69.5565 20.3049V14.2805H73.8276V15.4092H70.8365V16.6835H73.7548V17.8122H70.8365V19.1734H73.8164V20.3021H69.5565V20.3049ZM85.3638 20.3049V15.4092H83.5994V14.2805H88.4082V15.4092H86.655V20.3049H85.3638ZM98.8941 17.2997C98.8941 16.2354 98.2388 15.412 97.0064 15.412H95.917V19.179H97.0064C98.1883 19.179 98.8829 18.322 98.8829 17.3025H98.8941V17.2997ZM79.1574 17.2997C79.1574 16.2354 78.502 15.412 77.2697 15.412H76.1802V19.179H77.2697C78.4516 19.179 79.1462 18.322 79.1462 17.3025H79.1574V17.2997ZM47.3972 15.5633L46.4589 18.1567H48.3354L47.3972 15.5633ZM67.2123 16.2186C67.2123 15.7145 66.8258 15.4036 66.3105 15.4036H64.9633V17.0308H66.3105C66.8258 17.0308 67.2123 16.7256 67.2123 16.2158V16.2186Z" fill="white"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M13.8746 35.5484C14.7316 35.9293 15.1489 36.1785 15.3113 37.2428C15.5886 39.0997 13.8774 39.8055 12.2669 39.8055H8.48877V31.7086H12.2978C13.6645 31.7086 14.9136 32.3331 14.9136 33.8567C14.9136 34.6157 14.5187 35.1703 13.8718 35.5512L13.8746 35.5484ZM21.4393 35.5484C22.2963 35.9293 22.7137 36.1785 22.8761 37.2428C23.1534 39.0997 21.4421 39.8055 19.8317 39.8055H16.0535V31.7086H19.8625C21.2293 31.7086 22.4784 32.3331 22.4784 33.8567C22.4784 34.6157 22.0835 35.1703 21.4365 35.5512L21.4393 35.5484ZM30.4437 37.2484C30.2812 36.1841 29.8583 35.9349 29.0069 35.554C29.6538 35.1731 30.0544 34.6213 30.0544 33.8567C30.0544 32.3331 28.8052 31.7086 27.4385 31.7086H23.6295V39.8111H27.4077C29.0153 39.8111 30.7293 39.1053 30.4465 37.2484H30.4437ZM31.4967 37.8646V37.8478C31.4967 36.8227 32.3369 35.9797 33.3648 35.9797C34.3927 35.9797 35.2329 36.8199 35.2329 37.8422V37.859C35.2329 38.884 34.3927 39.727 33.3648 39.727C32.3453 39.7326 31.5023 38.8924 31.4967 37.8646ZM35.0621 37.859V37.8422C35.0564 36.9151 34.2919 36.1477 33.3648 36.1477C32.4378 36.1477 31.6676 36.9123 31.6676 37.845V37.8618C31.6732 38.7888 32.4378 39.5562 33.3648 39.5562C34.2919 39.5562 35.0621 38.7916 35.0621 37.859ZM32.631 36.8451H33.488C33.6953 36.8339 33.8998 36.9095 34.0566 37.0468C34.1602 37.1448 34.2134 37.2792 34.2134 37.4164V37.4276C34.2134 37.7357 34.0062 37.9206 33.7205 37.9934L34.3115 38.7636H33.9586L33.404 38.041H32.9167V38.7636H32.6338L32.6282 36.8479L32.631 36.8451ZM12.4266 38.2735H10.2112V36.4278H12.4266C14.0482 36.4278 13.9502 38.2735 12.4266 38.2735ZM19.9913 38.2735H17.7816V36.4278H19.9913C21.613 36.4278 21.5149 38.2735 19.9913 38.2735ZM25.3463 36.4278V38.2735H27.5561C29.0797 38.2735 29.1777 36.4278 27.5561 36.4278H25.3463ZM33.46 37.7833C33.7261 37.7833 33.9166 37.6573 33.9166 37.4417V37.4305C33.9166 37.2288 33.7541 37.1 33.4768 37.1H32.9111V37.7833H33.46ZM10.2112 33.2518H12.1969C13.4349 33.2518 13.4769 34.977 12.2725 34.977H10.2112V33.2518ZM25.3519 33.2518H27.3208C28.5588 33.2518 28.6008 34.977 27.3965 34.977H25.3407L25.3519 33.2518ZM17.7872 33.2518H19.7673C21.0052 33.2518 21.0472 34.977 19.8429 34.977H17.7816L17.7872 33.2518ZM12.1493 28.0816H15.8351L16.4904 30.3166H22.5148L23.1702 28.0816H26.8559L26.3742 26.4376H12.6338L12.1521 28.0816H12.1493ZM16.6109 14.8342L14.8268 17.2988C13.9306 18.5312 14.2079 20.7185 15.429 21.598L18.7394 23.987C19.308 24.3987 19.3528 24.8076 19.0811 25.2361L19.5628 25.5946L21.2405 23.2728C22.2767 21.836 22.1843 19.8867 20.6495 18.7636L17.3055 16.327C16.9106 16.0329 16.8657 15.6268 17.0842 15.1759L16.6109 14.8398V14.8342ZM19.476 3.95898L16.6977 7.80718C15.3954 9.60805 15.8687 12.686 17.6471 13.9996L22.2179 17.3521C23.145 18.0298 23.2654 19.7663 22.5932 20.6513L22.9797 20.9454L26.1333 16.5118C27.5505 14.5205 27.4693 11.5742 25.2427 9.96094L20.3526 6.40682C19.6693 5.91389 19.3276 5.06527 19.8961 4.25866L19.4788 3.95898H19.476Z" fill="#026495"/>
              </g>
              <defs>
              <clipPath id="clip0_4140_716">
              <rect width="112.592" height="42.0306" fill="white" transform="translate(0.383789 0.680664)"/>
              </clipPath>
              </defs>
            </svg>
          </div>
          <div id="aplus_logo_container">
            <svg width="100%" height="100%" viewBox="0 0 44 48" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6.59916 30H1.39715L9.3235 7.03938H15.5794L23.4945 30H18.2925L12.5411 12.2862H12.3617L6.59916 30ZM6.27404 20.975H18.5616V24.7644H6.27404V20.975ZM30.1434 26.5021V10.627H34.1571V26.5021H30.1434ZM24.2127 20.5713V16.5577H40.0878V20.5713H24.2127Z" fill="#006495"/>
              <path d="M2.10261 43.4707V32.5032H5.64241C6.4207 32.5032 7.07047 32.6442 7.59171 32.9263C8.11652 33.2048 8.51102 33.5921 8.77521 34.0884C9.04297 34.581 9.17685 35.1469 9.17685 35.786C9.17685 36.425 9.04297 36.9891 8.77521 37.4782C8.51102 37.9673 8.1183 38.3493 7.59706 38.6242C7.07582 38.8991 6.42963 39.0366 5.65848 39.0366H2.64349V38.1208H5.6317C6.20292 38.1208 6.67775 38.0262 7.05619 37.837C7.43819 37.6478 7.72202 37.3783 7.90767 37.0284C8.09688 36.6785 8.19149 36.2644 8.19149 35.786C8.19149 35.3076 8.09688 34.8899 7.90767 34.5329C7.71845 34.1723 7.43284 33.8938 7.05083 33.6974C6.6724 33.5011 6.194 33.4029 5.61563 33.4029H3.10404V43.4707H2.10261ZM6.93837 38.5225L9.6374 43.4707H8.48067L5.80842 38.5225H6.93837ZM13.1122 43.6581C12.6159 43.6581 12.1625 43.5617 11.752 43.369C11.3414 43.1726 11.0147 42.8906 10.772 42.5228C10.5292 42.1515 10.4078 41.7017 10.4078 41.1733C10.4078 40.7663 10.4846 40.4236 10.6381 40.1451C10.7916 39.8666 11.0094 39.6382 11.2914 39.4596C11.5735 39.2811 11.9073 39.1401 12.2928 39.0366C12.6784 38.9331 13.1033 38.8527 13.5674 38.7956C14.0279 38.7385 14.4171 38.6885 14.7348 38.6457C15.0561 38.6028 15.3007 38.535 15.4685 38.4422C15.6363 38.3493 15.7202 38.1994 15.7202 37.9923V37.7995C15.7202 37.239 15.5524 36.7981 15.2168 36.4768C14.8848 36.1519 14.4064 35.9895 13.7816 35.9895C13.1889 35.9895 12.7052 36.1198 12.3303 36.3804C11.959 36.641 11.6984 36.9481 11.5485 37.3015L10.6434 36.9748C10.8291 36.525 11.0861 36.1662 11.4146 35.8984C11.743 35.6271 12.1108 35.4325 12.5178 35.3147C12.9248 35.1933 13.3371 35.1326 13.7548 35.1326C14.069 35.1326 14.3956 35.1737 14.7348 35.2558C15.0775 35.3379 15.3953 35.4807 15.688 35.6842C15.9808 35.8842 16.2182 36.1644 16.4003 36.525C16.5824 36.882 16.6734 37.3354 16.6734 37.8852V43.4707H15.7202V42.1694H15.6613C15.547 42.4122 15.3774 42.6478 15.1525 42.8763C14.9276 43.1048 14.6456 43.2922 14.3064 43.4386C13.9672 43.5849 13.5692 43.6581 13.1122 43.6581ZM13.2407 42.7852C13.7477 42.7852 14.1868 42.6728 14.5581 42.4479C14.9294 42.2229 15.215 41.9248 15.4149 41.5535C15.6184 41.1787 15.7202 40.7663 15.7202 40.3165V39.1276C15.6488 39.1955 15.5292 39.2562 15.3614 39.3097C15.1971 39.3633 15.0061 39.4115 14.7884 39.4543C14.5742 39.4936 14.3599 39.5275 14.1457 39.556C13.9315 39.5846 13.7387 39.6096 13.5674 39.631C13.1033 39.6881 12.707 39.7774 12.3785 39.8988C12.0501 40.0202 11.7984 40.188 11.6234 40.4022C11.4485 40.6128 11.361 40.8841 11.361 41.2162C11.361 41.716 11.5395 42.1033 11.8965 42.3782C12.2536 42.6496 12.7016 42.7852 13.2407 42.7852ZM21.8458 35.2451V36.0752H17.9204V35.2451H21.8458ZM19.1468 33.2744H20.1053V41.3233C20.1053 41.666 20.1642 41.9355 20.2821 42.1319C20.3999 42.3247 20.5534 42.4621 20.7426 42.5443C20.9318 42.6228 21.1335 42.6621 21.3478 42.6621C21.4727 42.6621 21.5798 42.6549 21.6691 42.6406C21.7583 42.6228 21.8369 42.6049 21.9047 42.5871L22.1082 43.4493C22.0154 43.485 21.9011 43.5171 21.7655 43.5457C21.6298 43.5778 21.462 43.5939 21.2621 43.5939C20.9122 43.5939 20.5748 43.5171 20.2499 43.3636C19.9286 43.2101 19.6644 42.9816 19.4574 42.6781C19.2503 42.3747 19.1468 41.998 19.1468 41.5482V33.2744ZM23.4181 43.4707V35.2451H24.3767V43.4707H23.4181ZM23.9055 33.8313C23.7091 33.8313 23.5413 33.7653 23.4021 33.6332C23.2628 33.4975 23.1932 33.3351 23.1932 33.1459C23.1932 32.9566 23.2628 32.796 23.4021 32.6639C23.5413 32.5282 23.7091 32.4604 23.9055 32.4604C24.1018 32.4604 24.2696 32.5282 24.4088 32.6639C24.5481 32.796 24.6177 32.9566 24.6177 33.1459C24.6177 33.3351 24.5481 33.4975 24.4088 33.6332C24.2696 33.7653 24.1018 33.8313 23.9055 33.8313ZM27.2477 38.3297V43.4707H26.2945V35.2451H27.2209V36.5357H27.3066C27.4994 36.1144 27.7993 35.777 28.2063 35.5236C28.6168 35.2665 29.1238 35.138 29.7272 35.138C30.2805 35.138 30.7661 35.254 31.1838 35.4861C31.6051 35.7146 31.9317 36.0519 32.1638 36.4982C32.3994 36.9445 32.5172 37.4925 32.5172 38.1423V43.4707H31.564V38.2012C31.564 37.5264 31.3748 36.9927 30.9963 36.6C30.6215 36.2072 30.1181 36.0109 29.4862 36.0109C29.0542 36.0109 28.6704 36.1037 28.3348 36.2894C27.9992 36.475 27.7332 36.7428 27.5369 37.0926C27.3441 37.4389 27.2477 37.8513 27.2477 38.3297ZM37.5624 46.7267C37.0019 46.7267 36.511 46.6535 36.0897 46.5071C35.6685 46.3643 35.3132 46.1679 35.0241 45.918C34.7349 45.6681 34.51 45.3879 34.3493 45.0773L35.1312 44.5632C35.249 44.7702 35.4061 44.9737 35.6024 45.1737C35.8023 45.3736 36.0612 45.5396 36.3789 45.6717C36.7002 45.8038 37.0947 45.8698 37.5624 45.8698C38.2907 45.8698 38.878 45.6878 39.3243 45.3236C39.7741 44.9595 39.999 44.3936 39.999 43.626V41.7731H39.9134C39.8027 42.023 39.6438 42.2729 39.4367 42.5228C39.2297 42.7692 38.9584 42.9745 38.6228 43.1387C38.2907 43.3029 37.8784 43.385 37.3857 43.385C36.7288 43.385 36.1451 43.2226 35.6345 42.8977C35.1276 42.5728 34.7277 42.1087 34.435 41.5053C34.1458 40.8984 34.0012 40.1755 34.0012 39.3365C34.0012 38.5046 34.1422 37.7728 34.4243 37.1408C34.7099 36.5089 35.108 36.0162 35.6185 35.6628C36.129 35.3094 36.7234 35.1326 37.4018 35.1326C37.9052 35.1326 38.3229 35.2219 38.6549 35.4004C38.9869 35.5753 39.2529 35.7931 39.4528 36.0537C39.6563 36.3144 39.8152 36.5678 39.9294 36.8142H40.0258V35.2451H40.9576V43.6849C40.9576 44.3811 40.8095 44.9541 40.5131 45.4039C40.2168 45.8538 39.8134 46.1858 39.3029 46.4C38.7923 46.6178 38.2122 46.7267 37.5624 46.7267ZM37.4982 42.5121C38.0265 42.5121 38.4782 42.3854 38.853 42.1319C39.2279 41.8748 39.5153 41.5071 39.7152 41.0287C39.9151 40.5503 40.0151 39.9809 40.0151 39.3204C40.0151 38.6778 39.9169 38.1083 39.7206 37.6121C39.5242 37.1123 39.2386 36.7196 38.8637 36.434C38.4924 36.1448 38.0373 36.0002 37.4982 36.0002C36.9484 36.0002 36.4842 36.1483 36.1058 36.4447C35.7274 36.741 35.4418 37.1408 35.249 37.6442C35.0562 38.1441 34.9598 38.7028 34.9598 39.3204C34.9598 39.9488 35.058 40.5039 35.2543 40.9859C35.4507 41.4643 35.7381 41.8391 36.1165 42.1105C36.495 42.3782 36.9555 42.5121 37.4982 42.5121Z" fill="#006495"/>
            </svg>
          </div>
        <div>
          <svg xmlns="http://www.w3.org/2000/svg" width="2" height="36" viewBox="0 0 2 36" fill="none">
            <path d="M1 0V36" stroke="#B2B2B2" stroke-width="0.5"/>
          </svg>
        </div>
        <div class="cardiff-trademark-text">
          © 2025 Cardiff, Inc
        </div>
         </div>
      </div>
    </footer>
    <div v-if="!prod && !affil" id="stagingmenu">
      <div style="display: flex">
        <div style="flex: 1; padding-left: 10px">
          <p
            style="
              font-weight: bold;
              font-variant: all-small-caps;
              margin-bottom: 0px;
              text-align: center;
            "
          >
            IFF Staging Menu ({{
              model.sfleadid ? "Lead ID:" + model.sfleadid : "NOT COMMITTED"
            }})
          </p>
          <div
            style="
              flex: 1;
              display: flex;
              text-align: center;
              align-items: center;
              margin-bottom: 10px;
            "
          >
            <div
              style="
                flex: 1 1 auto;
                cursor: pointer;
                margin: 0 auto;
                max-width: 40px;
                background-color: #276cda;
                border-color: transparent;
                color: #fff;
                border-radius: 5px;
                padding: 5px;
              "
              @click="page > 0 ? page-- : console.log('cant')"
            >
              -
            </div>
            <div style="text-align: center; margin-bottom: 5px">
              Page {{ page }}/{{ maxPage }} ({{
                isMobile() ? "Mobile" : "Desktop"
              }})
            </div>
            <div
              style="
                flex: 1 1 auto;
                cursor: pointer;
                margin: 0 auto;
                max-width: 40px;
                background-color: #276cda;
                border-color: transparent;
                color: #fff;
                border-radius: 5px;
                padding: 5px;
              "
              @click="page < maxPage ? page++ : console.log('cant')"
            >
              +
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "@/assets/modal_ad.css";
import {
  GetStarted,
  // PersonalInfoApply,
  BankVerify,
  BusinessInfo,
  IFF,
  VerifyOwnership,
  // Signature,
  UploadDoc,
  // LoanInfo,
  Plaid,
  PlaidResult,
  ApprovalApply,
  // PersonalInfo,
} from "@/components/apply/pages";
import { build } from "@/tools/modelBuilder";
import CONSTANTS from "@/tools/translations.js";
import $ from "jquery";
import Vue from "vue";
import BusinessAddressIFF from "./apply/pages/BusinessAddressIFF.vue";

let location = window.location.href;

function setWithExpiry(key, value, ttl) {
  const now = new Date();
  // `item` is an object which contains the original value
  // as well as the time when it's supposed to expire
  const item = {
    value: value,
    expiry: now.getTime() + ttl,
  };
  localStorage.setItem(key, JSON.stringify(item));
}

function getWithExpiry(key) {
  const itemStr = localStorage.getItem(key);
  // if the item doesn't exist, return null
  if (!itemStr) {
    return null;
  }
  const item = JSON.parse(itemStr);
  const now = new Date();
  // compare the expiry time of the item with the current time
  if (now.getTime() > item.expiry) {
    // If the item is expired, delete the item from storage
    // and return null
    localStorage.removeItem(key);
    return null;
  }
  return item.value;
}

function resetProgress() {
  console.log("resetting progress");
  setWithExpiry("leadid", null, 1);
  window.location.reload();
}

let validate =
  location.indexOf("://cardiff") > -1 || location.indexOf("www.cardiff") > -1;
  // validate = true;
console.log("validate", validate);
export default {
  name: "ApplyIFF",
  components: {
    GetStarted,
    BankVerify,
    BusinessInfo,
    IFF,
    UploadDoc,
    Plaid,
    PlaidResult,
    ApprovalApply,
    VerifyOwnership,
    BusinessAddressIFF,
  },
  data() {
    return {
      page: 0,
      maxCompleteApp: 5,
      maxPage: 10,
      progress: 0,
      progress_css: 0,
      demo: false,
      customerId: null,
      item_id: null,
      scrolled: false,
      loading: false,
      plaid: null,
      iff_prefill: null,
      prod: validate,
      modal: {
        show: false,
        shown: false,
        html: "",
      },
      modal_reminder: {
        show: false,
        shown: false,
        html: "",
      },
      // seconds_elapsed: 0,
      utm_app_cta: false,
      marketing_cloud_campaign: "",
      affil: null,
      finishText: [
        { str: "You’ll receive a qualification confirmation via SMS and/or email. Your Cardiff Account Manager will guide you through the funding process." },
        { str: "What's next?" },
        { str: "1. If you are subscribed, you will receive a welcome SMS shortly." },
        { str: "2. Within the next 10 mins, you'll get a notification via SMS and email confirming your qualification." },
        { str: "3. Your dedicated Cardiff Account Manager will reach out and walk you through the funding process." },
      ],
      model: { sfleadid: null },
      tags: [],
    };
  },
  computed: {},
  methods: {
    mouseleave(event) {
      // if (parseInt(event.clientY) < 50) {
      //   console.log("should show up the modal window");
      //   this.modal_reminder.show = true;
      // }
    },
    closeModalAd() {
      var self = this;
      self.modal_reminder.show = false;
      // self.seconds_elapsed = 0;
      self.utm_app_cta = true;
    },

    isMobile: function () {
      var check = false;
      (function (a) {
        if (
          /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
            a
          ) ||
          /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
            a.substr(0, 4)
          )
        )
          check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    },
    sendPlaidPage: function(){
      this.page = 5;
    }, 
    incrementPage: function (pageData) {
      var self = this;
      console.log("pageData", pageData);
      this.model = build(this.model, pageData);
      if (pageData.customerId) {
        // console.log("we have the customer id ", pageData.customerId);
        this.customerId = pageData.customerId;
      }
      if (pageData.item_id) {
        this.item_id = pageData.item_id;
        self.plaid = {
          item_id: pageData.item_id,
          access_token: pageData.access_token,
        };
      }

      if (
        pageData &&
        pageData.inputs &&
        pageData.inputs.classification &&
        pageData.inputs.classification.value
      ) {
        setWithExpiry(
          "classification",
          pageData.inputs.classification.value,
          900000
        );
      }
      if (
        pageData &&
        pageData.inputs &&
        pageData.inputs.name &&
        pageData.inputs.name.value
      ) {
        setWithExpiry("company_name", pageData.inputs.name.value, 900000);
      }

      if ( pageData && pageData.inputs && pageData.inputs.tid && pageData.inputs.tid.value ) {
        console.log("found tid");
        setWithExpiry("tid", pageData.inputs.tid.value, 900000);
      }
      if (pageData && pageData.inputs && pageData.inputs.srfico && pageData.inputs.srfico.value ){
        console.log("found srfico");
        setWithExpiry("srfico", pageData.inputs.srfico.value, 900000);
      }
      if (pageData && pageData.inputs && pageData.inputs.zip && pageData.inputs.zip.value) {
        console.log("found zip");
        setWithExpiry("zip", pageData.inputs.zip.value, 900000);
      }
      if (pageData && pageData.inputs && pageData.inputs.requestedAmount && pageData.inputs.requestedAmount.value) {
        console.log("found requested Amount");
        setWithExpiry("requested_amount", pageData.inputs.requestedAmount.value, 900000);
      }
      
      if (pageData && pageData.inputs && pageData.inputs.smsOptIn) {
        console.log("found smsOptIn");
        if(pageData.inputs.smsOptIn.value){
          setWithExpiry("sms_optin_subscribed", pageData.inputs.smsOptIn.value, 900000);
        }else{
          setWithExpiry("sms_optin_subscribed", false, 900000);
        }
      }

      if (pageData.iff_prefill) {
        self.iff_prefill = pageData.iff_prefill;
        // alert('iff_prefill', JSON.stringify(pageData.iff_prefill))
        self.page = 3; //same page as VerifyOwnership component, or after?
        // console.log(
        //   "iff_prefill page",
        //   "current model",
        //   self.model,
        //   "iff prefill",
        //   pageData.iff_prefill
        // );
        let m = self.model.pg;
        let p = pageData.iff_prefill;
        m.fn = p.fn;
        m.ln = p.ln;
        m.address = p.address;
        m.city = p.city;
        m.state = p.state;
        m.zip = p.zip;
        m.dob = p.dob;
        m.ssn =
          p.ssn.substr(0, 3) +
          "-" +
          p.ssn.substr(3, 2) +
          "-" +
          p.ssn.substr(5, 4);
        m.iff = true;
      }

      //following variables are used to send data to google
      if (window.custom_data == undefined) {
        window.custom_data = {};
        window.custom_data.country = "US";
      }
      if (this.model.business && this.model.business.email !== undefined) {
        window.custom_data.email = this.model.business.email;
        setWithExpiry("email", this.model.business.email, 900000);
      }
      if (this.model.business && this.model.business.fn !== undefined) {
        window.custom_data.first_name = this.model.business.fn;
        setWithExpiry("first_name", this.model.business.fn, 900000);
      }
      if (this.model.business && this.model.business.ln !== undefined) {
        window.custom_data.last_name = this.model.business.ln;
        setWithExpiry("last_name", this.model.business.ln, 900000);
      }
      if (this.model.business && this.model.business.address !== undefined) {
        window.custom_data.street = this.model.business.address;
        setWithExpiry("street", this.model.business.address, 900000);
      }
      if (this.model.business && this.model.business.city !== undefined) {
        window.custom_data.city = this.model.business.city;
        setWithExpiry("city", this.model.business.city, 900000);
      }
      if (this.model.business && this.model.business.state !== undefined) {
        window.custom_data.state = this.model.business.state;
        setWithExpiry("state", this.model.business.state, 900000);
      }
      if (this.model.business && this.model.business.zip !== undefined) {
        window.custom_data.postal_code = this.model.business.zip;
        setWithExpiry("postal_code", this.model.business.zip, 900000);
      }
      if (this.model.business && this.model.business.phone !== undefined) {
        window.custom_data.phone_number = this.model.business.phone;
        let phone_normalized = this.model.business.phone.replace(/[^\d]/g, "");
        phone_normalized = "+1" + phone_normalized;
        setWithExpiry("phone_number", phone_normalized, 900000);
      }

      if (
        this.model.business &&
        this.model.business.startMonthNumber &&
        this.model.business.startMonthNumber !== undefined
      ) {
        setWithExpiry(
          "startMonthNumber",
          this.model.business.startMonthNumber,
          8000000
        );
      }

      if (
        this.model.business &&
        this.model.business.startYear &&
        this.model.business.startYear !== undefined
      ) {
        setWithExpiry("startYear", this.model.business.startYear, 900000);
      }
      if (
        this.model.business &&
        this.model.business.products &&
        this.model.business.products !== undefined
      ) {
        setWithExpiry("products", this.model.business.products, 900000);
      }
      // console.log(pageData.inputs);
      if (
        pageData &&
        pageData.inputs &&
        pageData.inputs.monthly_sales &&
        pageData.inputs.monthly_sales.value
      ) {
        setWithExpiry(
          "monthly_sales",
          pageData.inputs.monthly_sales.value,
          8000000
        );
      }

      // if (pageData.validate){
      //send the api request
      $.ajax({
        type: "POST",
        url: "/api/apply/lead",
        contentType: "application/json",
        dataType: "json",
        data: JSON.stringify({
          model: self.model,
          page: self.page,
          utm_app_cta: self.utm_app_cta,
          marketing_cloud_campaign: self.marketing_cloud_campaign,
        }),
      })
        .done(function (response) {
          console.log('response from lead update:');
          console.log(response);
          if (response.leadid) {
            console.log("setting leadid in model", response.leadid);
            self.model.sfleadid = response.leadid;

            //save to local storage
            setWithExpiry("leadid", response.leadid, 900000);
          }
          if (response.page) {
            if (response.page == 2) {
              // ttq.load("C443S04787TERR100EAG");

              fbq("track", "CompleteRegistration");
              // dataLayer.push({ event: "Contact Form" });

              window.uetq = window.uetq || [];
              window.uetq.push("event", "contact_filled", {});
            }

            if (response.page == 6) {
              // ttq.load("C443S04787TERR100EB0");

              // dataLayer.push({ event: "Complete App" });

              window.uetq = window.uetq || [];
              window.uetq.push("event", "finished_app", {});
            }

            if (response.page == 11) {
            }
          }
          if (response.mql_type) {
            console.log("setting mql_type in model", response.mql_type);
            self.model.mql_type = response.mql_type;
            //save to local storage
            setWithExpiry("mql_type", response.mql_type, 900000);
          }
          if (typeof response.datamerch_hit !== "undefined" ) {
            console.log("setting datamerch_hit in model", response.datamerch_hit);
            self.model.datamerch_hit = response.datamerch_hit;
            //save to local storage
            setWithExpiry("datamerch_hit", response.datamerch_hit, 900000);
          }
        })
        .fail(function (err) {
          console.log(err.responseText);
          self.invalid = true;
        });
      // }

      this.page++;

      let monthly_sales = getWithExpiry("monthly_sales");
      console.log("monthly_sales: " + monthly_sales);
      // console.log("page: " + self.page);
      let monthly_sales_float = 0;
      if (monthly_sales && typeof monthly_sales ==='string' && monthly_sales != "") {
        monthly_sales_float = parseFloat(monthly_sales.replace(/,/g, ""));
      } else if (monthly_sales && typeof monthly_sales ==='number' && monthly_sales != "") {
        monthly_sales_float = monthly_sales;
      }

      // if (monthly_sales_float < 10000 && self.page == 3) {
      //we set page 9 but it will convert into page 10 later at the end of the method
      // self.page = 5;
      // self.page = 8;
      // }
      let product_interest_array = getWithExpiry("products");
      let product_type = "WC";
      let product_interest = "";
      if (product_interest_array && product_interest_array.length > 0) {
        product_interest = product_interest_array.toString();
      }
      // console.log("product interest array: ", product_interest_array);
      // console.log("product interest string: ", product_interest);
      if (
        product_interest == "Equipment Financing" ||
        product_interest == "Vehicle Financing" ||
        product_interest == "Equipment Financing,Vehicle Financing"
      ) {
        product_type = "EF";
      }

      let mql_type = getWithExpiry("mql_type");
      let datamerch_hit = getWithExpiry("datamerch_hit");

      console.log("product type: ", product_type);
      let startMonthNumber = getWithExpiry("startMonthNumber");
      let startYear = getWithExpiry("startYear");

      let months_since_company_start = 0;
      var start_date = startMonthNumber + startYear + "";
      start_date = start_date.trim();
      console.log('start date',start_date);
      if (start_date && start_date !== "" && start_date) {
        let dateFrom = new Date(startYear, startMonthNumber);
        let dateTo = new Date();
        months_since_company_start =
          dateTo.getMonth() -
          dateFrom.getMonth() +
          12 * (dateTo.getFullYear() - dateFrom.getFullYear());
      }
      console.log("months in Biz: " + months_since_company_start);

      if (self.page == 3) {
        //IFF for experian
        //monthly sales > 10 y no cumple con EF mandalo insertar los datos de SSN
        //monthly sales < 10 y no cumple con EF mandalo pagina 9
        // if (product_type == "WC" && monthly_sales_float < 10000) {
        //   console.log("wc and <10k");
        //   self.page = 8; //skip asking this user
        // } else if (months_since_company_start <= 18 && product_type == "EF") {
        //   console.log("ef and <=18m");
        //   self.page = 8;
        // }
        // if (product_type == "WC" && monthly_sales_float >= 10000) {
        //   console.log("wc and >10k");
        //   self.page = 4; //add data for owner without running experian
        // } else if (product_type == "WC" && monthly_sales_float < 10000) {
        //   console.log("wc and <10k");
        //   self.page = 8; //skip asking this user
        // } else if (months_since_company_start > 18 && product_type == "EF") {
        //   console.log("ef and >18m");
        //   self.page = 3;
        // } else if (months_since_company_start <= 18 && product_type == "EF") {
        //   console.log("ef and <=18m");
        //   self.page = 8;
        // }
      }

      if (self.page == 5) {
        console.log("product type: ", product_type);
        console.log("months_since_company_start: ", months_since_company_start);
        if(monthly_sales_float >= 20000 && months_since_company_start >= 12 && datamerch_hit === false){
          // do nothing, send them to plaid, qualifies for WC
          console.log("WC and >=20k and tib > 8m, qualified for WC");
        }
        // if(mql_type ==='EF' || (months_since_company_start >= 24 && product_type == "EF")){
        //   // ask for DL and VCheck
        //   console.log("ask for DL and VCheck, qualified for EF");
        //   self.page = 8; //skip asking this user
        // }
        else if(mql_type ==='DNQ'){
          // do nothing, send them to approval page
          console.log("its DNQ");
          self.page = 10; //skip asking this user
        }
        // nano-fi if
        // else if (monthly_sales_float < 15000) {
          // start nanofi
          // $("#plaid_ad_container").hide();
          // $("#submit_leads_ad").show();
          // setTimeout(function () {
          //   $("#plaid_ad_container").hide();
          //   $("#submit_leads_ad").show();
          // }, 1000);
          // setTimeout(function () {
          //   $("#plaid_ad_container").hide();
          //   $("#submit_leads_ad").show();
          // }, 2000);
          // setTimeout(function () {
          //   $("#plaid_ad_container").hide();
          //   $("#submit_leads_ad").show();
          // }, 3000);
          // setTimeout(function () {
          //   $("#plaid_ad_container").hide();
          //   $("#submit_leads_ad").show();
          // }, 5000);
          // console.log("data sent");
          // $.ajax({
          //   type: "POST",
          //   url: "/api/apply/submit_lead",
          //   contentType: "application/json",
          //   dataType: "json",
          //   data: JSON.stringify({ model: self.model }),
          // }).done(function (response) {
          //   console.log(response);
          //   if (response.link != "") {
          //     console.log("hacemos el redirect"); // $(location).attr("href", response.link);
          //     window.location.replace(response.link);
          //   }
          //   if (response.error) {
          //     console.log(response.message);
          //   }
          // });
          // end nanofi

          // in case nanofi is disabled send this code.
        //   self.page = 8;
        // }
      }

      // self.seconds_elapsed = 0;
      window.scrollTo(0, 0);
      console.log(self.page);
      if (self.page == 5 || self.page == 7) {
        // console.log("100%");
        // $("#transition_container").css("max-width", "100%");
      } else {
        // console.log("600px");
        // $("#transition_container").css("max-width", 600);
      }
    },
    scrollListener: function () {
      var scrollTop =
        window.pageYOffset ||
        (document.documentElement || document.body.parentNode || document.body)
          .scrollTop;
      if (scrollTop > 60) {
        this.scrolled = true;
      } else {
        this.scrolled = false;
      }
    },
    mouseListener: function (e) {
      var y = window.Event
        ? e.pageY
        : event.clientY +
          (document.documentElement.scrollTop
            ? document.documentElement.scrollTop
            : document.body.scrollTop);
      if (y < 5 && !this.modal.shown) {
        this.modal.show = true;
        this.modal.shown = true;
      }
    },
  },
  created: function () {
    this.language = "en";
    if (this.$route.params.language) {
      this.language = this.$route.params.language;
    }
    var tags = [];
    var language = this.language;
    $.each(CONSTANTS, function (key, value) {
      var translation = value[language];
      tags[key] = value[language];
    });

    this.tags = tags;
    Vue.prototype.$language = this.language;
  },
  mounted: function () {
    console.log("v3 - iff");
    atadlauq.atadlauqs(null);
    var self = this;
    document.title = "Apply For a Business Loan Today | Cardiff.co";
    window.addEventListener("scroll", this.scrollListener);
    setTimeout(function () {
      if (window.Event) {
        document.captureEvents(Event.MOUSEMOVE);
      }
      // document.onmousemove = self.mouseListener;
    }, 10000);

    this.scrollListener();

    setWithExpiry("external_id", external_id, 4000000);

    // console.log(self.$route.query);
    if (self.$route.query.fbclid) {
      // console.log(self.$route.query.fbclid);
      // console.log("save click in cookies");
      setWithExpiry("fbclid", self.$route.query.fbclid, 4000000);
    }
    if (self.$route.query.gclid || self.$route.query.wbraid) {
      console.log(self.$route.query.gclid);
      console.log("save gclid in cookies");
      setWithExpiry("gclid", self.$route.query.gclid, 4000000);
    }
    if (self.$route.query.ttclid) {
      setWithExpiry("ttclid", self.$route.query.ttclid, 4000000);
    }
    if (self.$route.params.provider) {
      self.affil = self.$route.params.provider;
    }

    if (self.$route.query.utm_marketing_cloud_campaign) {
      self.marketing_cloud_campaign =
        self.$route.query.utm_marketing_cloud_campaign;
      setWithExpiry(
        "marketing_cloud_campaign",
        self.$route.query.utm_marketing_cloud_campaign,
        4000000
      );
    }

    let c = document.cookie.split("; ");
    // console.log(c)
    let cookies = {};

    for (let i = c.length - 1; i >= 0; i--) {
      let C = c[i].split("=");
      cookies[C[0]] = C[1];
    }
    let fbp = cookies["_fbp"];
    if (fbp) {
      setWithExpiry("_fbp", fbp, 4000000);
    }

    const leadId = getWithExpiry("leadid");

    // self.modal_reminder.show = true;
    // figure out what page we were on
    // console.log(self.$route.query);
    if (
      self.$route.query &&
      self.$route.query.oauth_state_id &&
      self.$route.query.oauth_state_id !== ""
    ) {
      setWithExpiry(
        "oauth_state_id",
        self.$route.query.oauth_state_id,
        4000000
      );
    }

    if (leadId || self.$route.params.code) {
      self.loading = true;
      self.model.sfleadid = self.$route.params.code
        ? self.$route.params.code
        : leadId;
      self.modal.show = true;
      self.modal.html =
        "<h2>Welcome back!</h2><p>We're loading your application so you can pick up where you left off.</p> <a class='button is-link is-loading is-large is-fullwidth'>Loading</a>";
      // figure out what page we were on

      let oauth_token = getWithExpiry("oauth_state_id");
      console.log("oauth token:" + oauth_token);
      if (oauth_token && oauth_token !== "") {
        console.log("found oauth in ApplyIFF ");
        //when we have oauth token the user came from a redirection from the bank website
        self.modal.show = false;
        self.loading = false;
      }
      $.ajax({
        type: "POST",
        url: "/api/apply/load-progress",
        contentType: "application/json",
        dataType: "json",
        data: JSON.stringify({ leadid: self.model.sfleadid }),
      })
        .done(function (response) {
          //self.$route.query.oauth_state_id
          //if page = page + 1
          self.loading = false;
          console.log(" response.page: " + response.page);
          if (response.page && oauth_token && oauth_token !== "") {
            console.log("found oauth in ApplyIFF ");
            //when we have oauth token the user came from a redirection from the bank website
            self.page = response.page;

            console.log(" self.page: " + self.page);
          } else if (response.page) {
            self.page = response.page;
          }
          if (response.appdata) {
            self.model.business = {};
            self.model.business.address = response.appdata.address;
            self.model.business.name = response.appdata.name;
            self.model.business.state = response.appdata.state;
            self.model.business.monthly_sales = response.appdata.monthly_sales;
            if (
              response.appdata.monthly_sales &&
              response.appdata.monthly_sales !== undefined
            ) {
              setWithExpiry("monthly_sales",response.appdata.monthly_sales,8000000);
            }
            if (response.appdata.mql_type && response.appdata.mql_type !== undefined) {
              setWithExpiry("mql_type",response.appdata.mql_type,8000000);
            }
            self.modal.html =
              "<h2>We found your application for " +
              self.model.business.name +
              "!</h2><p><a href='#' id='resetProgressButton'>Click here</a> to start a new application instead.</p> <a class='button is-link is-loading is-large is-fullwidth'>Loading</a>";

            setTimeout(() => {
              document
                .getElementById("resetProgressButton")
                .addEventListener("click", resetProgress, false);
            }, 500);
          }
          setTimeout(() => {
            self.modal.show = false;
          }, 5000);
        })
        .fail(function (err) {
          console.log(err.responseText);
          alert(err.responseText);
          self.invalid = true;
          self.loading = false;
          self.modal.show = false;
          self.page = 12;
        });
    }
    //this was redirecting to an empty url
    // if (self.$route.params) {
    //   if (self.prod) self.$router.replace({ path: `/apply/` });
    // }

    // window.addEventListener("beforeunload", function (e) {
    //   e.preventDefault();
    //   e.returnValue = "";
    // });

    // var cancel = setInterval(function () {
    //   console.log("counting2: " + self.seconds_elapsed);
    //   self.seconds_elapsed += 1;
    //   if (self.seconds_elapsed >= 5) {
    //     self.modal_reminder.show = true;
    //   }
    // }, 1000);
  },
  watch: {
    page: function (newValue, oldValue) {
      // console.log("Old vaule: " + oldValue);
      console.log("Current page value: " + newValue);
      if (newValue == 5 || newValue == 7) {
        // $("#transition_container").css("max-width", "100%");
      } else {
        // $("#transition_container").css("max-width", 600);
      }
      if (newValue === 4) {
        // $("#transition_container").css("background-size", "cover");
      }else{
        // $("#transition_container").css("background-size", "contain");
      }

      console.log("this page", this.page)
      if(this.progress < 100){
        this.progress = (this.page+1) * 100 / this.maxCompleteApp;
        this.progress_css = (this.page+1) * 100 / this.maxCompleteApp;
      }
      
    },
    // $data: {
    //   handler: function (newValue) {
    //     console.log("Current vaules: " + newValue.page);
    //     if (newValue.page == 3 || newValue.page == 5) {
    //       $("#transition_container").css("max-width", "100%");
    //     } else {
    //       $("#transition_container").css("max-width", 600);
    //     }
    //   },
    //   deep: true,
    // },
  },
};
</script>
<style>
#app-column h2{
  color: #000;
text-align: center;
font-family: Roboto;
font-size: 20px;
font-style: normal;
font-weight: 600;
line-height: normal;
}
#app-column h3{
  color: #000;
  font-family: Roboto;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.navbar {
  background-color: #3c5cac;
  z-index: 2;
}
.navbar-workingcapital {
  background-color: #2b286b;
  z-index: 2;
}
.navbar-elevator,.navbar-elevatorfunding,.navbar-elevatorfundingsite, .navbar-meltzerfunding {
  background-color: #3c5cac;
  z-index: 2;
}
/* .navbar-elevator .navbar-item,.navbar-elevatorfunding .navbar-item, .navbar-elevatorfundingsite .navbar-item, .navbar-meltzerfunding .navbar-item{
  padding-top: 24px!important;
  padding-bottom: 24px!important;
} */
.navbar-drivenfunding,.navbar-drivenfundingsite {
  background-color: #3c5cac;
  z-index: 2;
}
/* .navbar-drivenfunding .navbar-item,.navbar-drivenfundingsite .navbar-item{
  padding-top: 24px!important;
  padding-bottom: 24px!important;
} */
.navbar-empireoperatingsystemsite,.navbar-empireoperatingsystemsite {
  background-color: #3c5cac;
  z-index: 2;
}
/* .navbar-empireoperatingsystemsite .navbar-item,.navbar-empireoperatingsystemsite .navbar-item{
  padding-top: 24px!important;
  padding-bottom: 24px!important;
} */
.navbar-spoffordfunding {
  background-color: #3c5cac;
  z-index: 2;
}
/* .navbar-spoffordfunding .navbar-item{
  padding-top: 24px!important;
  padding-bottom: 24px!important;
} */
.navbar-thefraternity {
  background-color: #000;
  z-index: 2;
}
/* .navbar-thefraternity .navbar-item{
  padding-top: 24px!important;
  padding-bottom: 24px!important;
} */
.navbar-tscfunding {
  background-color: #3c5cac;
  z-index: 2;
}
/* .navbar-tscfunding .navbar-item{
  padding-top: 24px!important;
  padding-bottom: 24px!important;
} */
.navbar-tcsfunding {
  background-color: #3c5cac;
  z-index: 2;
}
/* .navbar-tcsfunding .navbar-item{
  padding-top: 24px!important;
  padding-bottom: 24px!important;
} */
.navbar-croakfundingpartners {
  background-color: #3c5cac;
  z-index: 2;
}
/* .navbar-croakfundingpartners .navbar-item{
  padding-top: 24px!important;
  padding-bottom: 24px!important;
} */
.navbar-iconindustriesfunding {
  background-color: #3c5cac;
  z-index: 2;
}
/* .navbar-iconindustriesfunding .navbar-item{
  padding-top: 24px!important;
  padding-bottom: 24px!important;
} */
.navbar-smtffranchising {
  background-color: #3c5cac;
  z-index: 2;
}
/* .navbar-smtffranchising .navbar-item{
  padding-top: 24px!important;
  padding-bottom: 24px!important;
} */
.navbar-saloncapitalfunding {
  background-color: #3c5cac;
  z-index: 2;
}
/* .navbar-saloncapitalfunding .navbar-item{
  padding-top: 24px!important;
  padding-bottom: 24px!important;
} */
.navbar-realmoneylending {
  background-color: #3c5cac;
  z-index: 2;
}
/* .navbar-realmoneylending .navbar-item{
  padding-top: 24px!important;
  padding-bottom: 24px!important;
} */

.navbar-recessionproofcapital {
  background-color: #3c5cac;
  z-index: 2;
}
/* .navbar-recessionproofcapital .navbar-item{
  padding-top: 24px!important;
  padding-bottom: 24px!important;
} */
.navbar-digitalsocialhour {
  background-color: #3c5cac;
  z-index: 2;
}
/* .navbar-digitalsocialhour .navbar-item{
  padding-top: 24px!important;
  padding-bottom: 24px!important;
} */
.navbar-saguarocactusholdingsfundingsite,.navbar-saguarocactusholdingsfundingsite {
  background-color: #3c5cac;
  z-index: 2;
}
.navbar-bataviamachinery{
  background: #576780;
}

/* .navbar-saguarocactusholdingsfundingsite .navbar-item,.navbar-saguarocactusholdingsfundingsite .navbar-item{
  padding-top: 24px!important;
  padding-bottom: 24px!important;
} */
.navbar-easypay {
  background-color: #1f5577;
  z-index: 2;
}
.navbar .navbar-brand {
  text-align: center;
  /* display: block; */
  width: 100%;
  height: 50px!important;
}

.navbar .navbar-brand > .navbar-item,
.navbar .navbar-brand .navbar-link {
  display: inline-block;
}
#transition_container{
  /* background: linear-gradient(235deg, rgba(0, 100, 221, 0.20) 0%, rgba(255, 255, 255, 0.00) 100%);
  flex-shrink: 0; */
  /* max-height: none; */
  background: url("https://cardiff.b-cdn.net/img/gradient-desktop2.png");
  
  background-repeat: no-repeat;
  margin-left: 0;
  /* background-size: contain; */
  background-size: cover;
  padding-top: 32px;
  min-height: 100%;
}
.tabs{
  margin-bottom: 0;
}

.progress-bar{
  /* background: linear-gradient(to right, #B993D6, #8CA6DB); */
  height: 4px;
  width: 15px;
  /* border-radius: 9px; */
  border-radius: 4px 0px 0px 4px;
  /* background: #3A67D2; */
  background: #28A745;
  vertical-align: middle;
  /* margin-left: 24px; */
  display: inline-block;
  max-width: 100%;
}
.progress-bar span {
    /* float: right; */
    padding: 4px 5px;
    color: #fff;
    font-size: 0.7em
}
#progress-label{
  color: #6e6d6d;
  text-align: center;
  font-family: Roboto;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: 0.3px;
  /* padding-right: 24px; */
  display: inline-block;
  height: 24px;
  width: 15%;
}
#progress-bar-container{
  display: inline-block;
  width: 85%;
  display: inline-block;
  margin-right: 0%;
  /* background: linear-gradient(180deg, 
    rgba(0,0,0,0) calc(50% - 1px), 
    rgb(211, 185, 185) calc(50%), 
    rgba(0,0,0,0) calc(50% + 4px)
  ); */
  /* background: linear-gradient(180deg, 
    rgba(0,0,0,0) calc(50% - 1px), 
    #708BB6,
    rgba(0,0,0,0) calc(50% + 4px)
  ); */

  /* position: relative; */
  /* height: 16px; */
                   /* total height of the container */
  background: 
    linear-gradient(
      180deg,
      transparent               calc(50% - 0px),  /* end of top-transparent */
      #708BB6                   calc(50% - 0px),  /* start of solid */
      #708BB6                   calc(50% + 4px),  /* end of solid */
      transparent               calc(50% + 4px)   /* start of bottom-transparent */
    );
  border-radius: 8px;     
  
  /* background-color: #F1F1F1; */
  position: relative;
}

#progress_bar_point_container{
  display: inline-block;
  position: absolute;
  left: -3px;
  top: 3px;
}
#progress-bar-main-container{
  max-width: 750px;
  width: 750px;
  height: 100px;
  margin: 0 auto;
  padding-top: 40px;
  padding-bottom: 40px;
}
#progress-bar-main-container-mobile{
  /* border-bottom: 1px solid #CCC;; */
  width: 67%;
  display: flex;
}
#progress-bar-container{
  text-align: left;
}
#progress-bar-container-parent{
  /* text-align: left; */
  width: 185px;
}
#nav-logo-container{
  width: 33%;
  padding-top: 14px;
  padding-left: 27px;
}
.tabs a{
  letter-spacing: 0;
  font-size: 14px;
}
#appcontainer {
  margin-left: 0px;
  margin-right: 0px;
  width: 100%;
  /* position: fixed; */
}
.desktop_container{
  display: block;
}
.mobile_container{
  display: none;
}
#logos-container{
  height: 76px;
  padding-top: 24px;
  /* border: 1px solid #CCC;; */
  display: inline-flex;
  margin-left: 32px;
  /* width: 40%; */
}
#ssl_logo_container{
  width: 56px;
  height: 40px;
  margin-right: 12px;
  margin-left: 56px;
} 
#bbb_logo_container{
  width: 100px;
  height: 40px;
  margin-right: 12px;
}
#aplus_logo_container{
  width: 44px;
  height: 40px;
  margin-right: 12px;
}

#tell-us-title{
  color: #000;
  font-family: Roboto;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: 0.2px;
  margin: 0 53px 0 53px;
}
#fill-out-title{
  color: #000;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: 0.16px;
  margin: 0 53px 0 53px;
}
@media (max-width: 64em) {
  #progress-label {
    /* width: 20%; */
    width: 40px;
    color: #FFF;
    text-align: center;
    font-family: Roboto;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    letter-spacing: 0.36px;
    padding-right: 0;
    padding-top: 5px;
    }
    #progress-bar-container-parent{
      width: 80%
    }
}

@media screen and (min-width: 1025px), print {
  .mobile-only {
    display: none;
  }
  #appcontainer {
    margin-left: 0px;
    margin-right: 0px;
    
  }
  .fullheight {
    /* min-height: 100vh; */
    /* height: 100vh; */
    height: 100%;
  }
  #app-column {
    /* padding: 20px 100px; */
    padding-top:0px;
  }
  .tabs a {
    font-size: 18px;
  }
  
}

@media screen and (max-width: 1024px) {
  #appcontainer{
    position: relative;
  }
  #cardiff-column {
    display: none;
  }
  #app-column {
    min-height: 100vh;
    padding-top: 0;
  }
  .fixed-tabs {
    position: fixed;
    z-index: 2;
    background: white;
    top: 0px;
    width: 100%;
    left: 0px;
    transition: all 0.3s;
  }
  /* .pushed-pages {
    margin-top: 55px !important;
  } */
  .desktop_container{
    display: none;
  }
}

@media (max-width: 47.999em) {
  #transition_container{
    background: url("https://cardiff.b-cdn.net/img/gradient-mobile-2.png");
    background-repeat: no-repeat;
    margin-left: 0;
    background-size: contain;
    padding-right: 24px;
    padding-left: 24px;
    padding-top: 32px;
  }
  #progress-bar-container{
    display: inline-block;
    width: 100%;
    position: relative;
    margin-right: 0%;
  }
  #progress-label{
    width: 20%;
    color: #FFF;
    text-align: center;
    font-family: Roboto;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    letter-spacing: 0.36px;
    padding-right: 0;
    padding-top: 5px;
  }
  .desktop_container{
    display: none;
  }
  .mobile_container{
    display: block;
  }
  #navbar_mobile{
    position:sticky;
    top: 0%;
    z-index: 1000;
  }
  #logos-container{
    height: 76px;
    padding-top: 24px;
    /* border: 1px solid #CCC;; */
    display: inline-flex;
    margin-left: 0px;
    /* width: 40%; */
  }
  #app-column {
    min-height: 87vh;
    min-height: 83vh;
    padding-top: 0;
    overflow-y: auto;
  }
  #ssl_logo_container{
    width: 36px;
    height: 25px;
    margin-right: 12px;
    margin-left: 0;
  } 
  #bbb_logo_container{
    width: 68px;
    height: 25px;
    margin-right: 12px;
  }
  #aplus_logo_container{
    width: 34px;
    height: 25px;
    margin-right: 12px;
  }
  .cardiff-trademark-text{
    font-size: 0.675em;
    margin-top: 0;
    font-size: 0.675em; 
    padding-left: 15px; 
    padding-top: 5px;
    color: #B2B2B2;
    font-family: Roboto;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }
}

.is-active {
  font-weight: bold;
}

#cardiff-column {
  /* background: #f1f1f1; */
  background: linear-gradient(
    90deg,
    rgb(246, 246, 246) 0%,
    rgb(242, 242, 242) 57%,
    rgb(237, 237, 237) 100%
  );
  z-index: 1;
  padding-top: 50px;
  max-width: 320px;
}

#logo {
  /* max-width: 50%; */
  margin: auto;
  display: block;
  /* margin-top: 10px; */
  /* margin-bottom: 10px; */
  width: 95px!important;
  height: 21px !important;
  max-width: 95px!important;
  object-fit: contain;
}

.next-button {
  margin-top: 10px;
}

.columns {
  margin-left: 0;
  margin-right: 0;
}

.no-margin {
  margin-bottom: 0px !important;
}

#stagingmenu {
  position: fixed;
  width: 100%;
  bottom: 0;
  background: #ecf3ff;
  opacity: 0.3;
  z-index: 1;
  transition: all 0.3s;
  /* display: none; */
}

#stagingmenu:hover {
  opacity: 1;
}

.listpage {
  margin-top: 0px;
}
.listpage-active {
  margin-top: 0px;
  font-weight: bold;
}
</style>